import { Configuration, Connection, Connector, ConnectorInfo, Entity, EntityCreateCallback, Material, MaterialFilter, Module, MeshVisibility, ModuleCreateCallback, Product, Project, ProjectFilter, Series, User, YUIContext } from "./types/type_def";
import { ErrorHandler, PDFHandler } from "./handlers";
import { ConversionHelper, CryptographyHelper, FormatHelper, MaterialSelector, MathHelper, ModuleHelper, ProductHelper, ProductSelector } from "./helpers";
import { configurationLibrary, materialLibrary, meshLibrary, productLibrary, projectLibrary, seriesLibrary } from "./libraries";
import { AppSettings } from "./settings";
import "../node_modules/parsleyjs";
import i18next from "../node_modules/i18next";
import i18nextHttpBackend from "../node_modules/i18next-http-backend";
import "./styles/site.less"
import { createEngine, createEnvironment, createGround, createLight, createMainCamera, createRenderTargetCamera, createScene, createShadowgenerator } from "./engine";
import FileSaver from "file-saver";

/*declare namespace i18next {
    function init(options: any): any
    function use(o: any): any
    function t(s: string, o?: any): any
}*/

//declare class i18nextHttpBackend { }

(window as any).YUI({
    "debug": (window.location.hostname.indexOf("localhost") >= 0) || (window.location.hostname.indexOf("cadesignform") >= 0),
    "combine": true,
    "comboBase": "https://yui.customizer.cadesignform.dk/combo?" // Everything is bundled so we do not rely on external source
}).use("node", "anim", "io", "handlebars", "event-outside", "datatype-number", "event", "event-delegate", "event-touch", "event-move", "dd", "scrollview", "scrollview-scrollbars", "slider", function (Y: YUIContext) {

    let canvas: HTMLCanvasElement;
    let engine: BABYLON.Engine;
    let scene: BABYLON.Scene;
    let mainCamera: BABYLON.ArcRotateCamera;
    let renderTargetCamera: BABYLON.ArcRotateCamera;
    let topviewCamera: BABYLON.ArcRotateCamera;
    let light: BABYLON.ShadowLight;
    let light2: BABYLON.ShadowLight;
    let sg: BABYLON.ShadowGenerator;
    let sg2: BABYLON.ShadowGenerator;
    let ground: BABYLON.Mesh;
    let ground2: BABYLON.Mesh;

    let rootNode: BABYLON.TransformNode;
    let modulesNode: BABYLON.TransformNode;
    let productsNode: BABYLON.TransformNode;
    let instanceNode: BABYLON.TransformNode;

    let GUI: BABYLON.GUI.AdvancedDynamicTexture;
   
    let currentModule: Module;
    let currentProduct: Product;
    let currentEntityNode: BABYLON.TransformNode;
    let currentConfiguration: Configuration;
    let currentProject: Project;
    let currentModuleNode: BABYLON.TransformNode;
    let currentConnector: BABYLON.TransformNode;
    let currentPage: string;
    let previousPage: string;

    let isNewConfig: boolean;

    let loggedIn: boolean = false;
    let render: boolean = true;
    let rendererInitialized: boolean = false;

    let isDragging: boolean = false;
    let isPlacing: boolean = false;
    let isOverCanvas: boolean = false;
    let hasPillows: boolean = false;
    let showMetrics: boolean = false;
    let meshLoading: boolean = false;

    let scaleFactor = 0.01;
    let connectorNodeSize = 0.2;

    let initialCameraRadius = 10;
    enum ACTIONS {
        NONE,
        DRAGOUT,
        DRAGOVER
    }

    let currentAction: ACTIONS = ACTIONS.NONE;

    let user: User;
    let viewMode: string;
    let materialFilters = [] as MaterialFilter[];

    let animRotation: BABYLON.Animatable;
    let animFitviewTarget: BABYLON.Animatable;
    let animFitviewRadius: BABYLON.Animatable;

    let dragPosition: BABYLON.Vector3 = BABYLON.Vector3.Zero();
    let scenePointerPosition: BABYLON.Vector3 = BABYLON.Vector3.Zero();
    let screenPointerPosition: BABYLON.Vector2 = BABYLON.Vector2.Zero();
    let cameraTarget: BABYLON.Vector3 = BABYLON.Vector3.Zero();
    let targetRotation: BABYLON.Vector3 = BABYLON.Vector3.Zero();

    let easingFunction = new BABYLON.BackEase(.0);
    easingFunction.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEOUT);

    let moduleHelper = new ModuleHelper();
    moduleHelper.setScaleFactor(scaleFactor);

    //Handlers 
    let pdfHandler = new PDFHandler();
    let errorHandler = new ErrorHandler(Y, ".errors");

    let projectFilter: ProjectFilter = {
        search: "",
        hideInactive: false,
        currentPage: 1,
        itemsShown: 20
    }
    i18next.use(i18nextHttpBackend).init({
        lng: 'en', // if you're using a language detector, do not define the lng option
        fallbackLng: 'en',
        ns: ['ui'],
        debug: true,
        backend: {
            loadPath: 'static/locales/{{lng}}/{{ns}}.json'
        }
    }).then(() => {
        const elements = document.querySelectorAll("[data-i18n]");
        elements.forEach(el => {

            if (el.hasAttribute("placeholder")) {
                let key = el.getAttribute("placeholder");
                let value = i18next.t(key) || key;
                el.setAttribute("placeholder", value);
            }

            if (el.hasAttribute("title")) {
                let key = el.getAttribute("title");
                let value = i18next.t(key) || key;
                el.setAttribute("title", value);
            }

            if (el.innerHTML) {
                let key = el.innerHTML;
                let value = i18next.t(key) || key;
                el.innerHTML = value;
            }

        });

        handleLogin();
    });

    //Render thumbnail
    window.addEventListener("thumbnail_render", function (e: Event) {
        renderConfigurationThumbnail(currentConfiguration);
    });

    window.addEventListener("thumbnail_rendered", function (e: Event) {
        updateConfigurationSelector();
        let summaryImage = Y.one(".summary-page .summary__description--series .summary-image");
        summaryImage.setAttribute("src", currentConfiguration.data.thumbnail);
    });

    window.addEventListener("saveconfigurations", function (e: Event) {
        saveProjectConfiguration();
    });

    window.addEventListener("removeconfiguration", function (e: Event) {

        configurationLibrary.removeConfiguration(currentConfiguration);
        updateConfigurationSelector();
        showPage("series");
        window.dispatchEvent(new Event("saveconfigurations"));

    });

    window.addEventListener("error", function (e: Event) {

        var hasError = errorHandler.errors.length > 0;

        var summaryMenuButton = Y.one(".summary-menu__button");
        summaryMenuButton.set("disabled", hasError ? "disabled" : null);

    });

    // @ts-ignore
    $("#editprojectform").parsley();
    // @ts-ignore
    $("#createprojectform").parsley();
    // @ts-ignore
    $("#openprojectform").parsley();

    //Selectors
    let productSelector = new ProductSelector(Y, productLibrary, Y.one(".product-selector"));
    let materialSelector = new MaterialSelector(Y, materialLibrary, Y.one(".material-selector"));
    materialSelector.selectCallBack = function () {

        pauseRender();
        showLoader();

        let count = 0;

        var entities = currentModule.entities.filter(x => productLibrary.getProductCategory(x.category) === "UPHOLSTRY");
        entities.forEach(entity => {

            //  let product = productLibrary.getProductByProductNo(entity.productNo);
            let productVariant = getProductVariant(entity.productNo, entity);
            let entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);

            let material = materialLibrary.getMaterialByProductNumber(currentConfiguration.data["material"]);
            if (material) {
                materialLibrary.assignMaterial(Y, productVariant, [entityNode], material, scene, function () {
                    entityNode.setEnabled(true);
                    count++;

                    if (count === entities.length) {

                        //window.dispatchEvent(new Event("saveconfigurations"));
                        resumeRender().then(() => {

                            //  constructModule(currentModule);
                            window.dispatchEvent(new Event("thumbnail_render"));
                            updateSummaryMenuTotalPrice();
                            hideLoader();

                        });

                    }
                });
            }
        });


    }
    materialSelector.selectGroupCallback = function () {
        var materialGroupModal = Y.one(".modals .material-group-modal");
        materialGroupModal.addClass("is-active");
        updateMaterialGroupModal();
    }

    //Reset configurations
    let resetConfigurations = function () {
        localStorage.removeItem("Configurations");
    }

    let displayBackButton = function (show: boolean) {
        var backButton = Y.one(".back-button");
        (show) ? backButton.addClass("show") : backButton.removeClass("show");
    }

    let displaySummaryButton = function (show: boolean) {
        var summaryMenuButton = Y.one(".summary-menu__button");
        (show) ? summaryMenuButton.addClass("show") : summaryMenuButton.removeClass("show");

        disableSummaryButton();
    }

    let disableSummaryButton = function () {
        var summaryMenuButton = Y.one(".summary-menu__button");
        summaryMenuButton.set("disabled", !currentModule || currentModule.entities.length === 0 ? "disabled" : null);
    }

    let updateSummaryMenuTotalPrice = function () {
        if (currentConfiguration == undefined) {
            return;
        }
        let series = seriesLibrary.getSeriesByName(currentConfiguration.series);

        var summaryMenuSeries = Y.one(".summary-menu__series");
        var summaryMenuSeriesName = summaryMenuSeries.one(".summary-menu__series__name");

        summaryMenuSeriesName.setHTML(series.name);

        var summaryMenuPrice = Y.one(".summary-menu__price");
        var summaryMenuPriceValue = summaryMenuPrice.one(".summary-menu__price__value");
        var summaryMenuPriceCurrency = summaryMenuPrice.one(".summary-menu__price__currency");

        var moduleTotalPrice = moduleHelper.getTotalModulePrice(currentModule, currentConfiguration);
        summaryMenuPriceValue.setHTML(FormatHelper.formatNumber(moduleTotalPrice.totalPrice));
        summaryMenuPriceCurrency.setHTML(moduleTotalPrice.currency);

    }

    let showPage = function (pageName: string) {

        previousPage = currentPage;

        Y.all("[data-page]").each(function (p) {
            p.removeClass("is-shown")
        });

        var shownPage = Y.one("[data-page='" + pageName + "']");
        shownPage.addClass("is-shown");

        handlePageSetup(pageName);
    }

    let handlePageSetup = async function (pageName: string) {

        currentPage = pageName;

        displayBackButton(false);
        displaySummaryButton(false);

        switch (pageName) {
            case "landing": {

            }
                break;
            case "configurations": {

                let identifierElem = Y.one("#openprojectform input");
                identifierElem.set("value", "");

                updateProjectsList();
            }
                break;
            case "series": {

                //  clearConfigurationAssets();
                cleanupAssets();
                currentModule = null;
                currentModuleNode = null;

                displaySummaryMenu(false);
                showSeriesWizardStep("series");

                //Update series list             
                updateSeriesList();

            }
                break;

            case "viewport": {
                updateConfigurationSelector();
                displaySummaryButton(true);
            }
                break;
            case "summary": {
                displayBackButton(true);
            }
        }
    }

    //Initialization
    let initApp = function () {

        viewMode = "module";
        resetConfigurations();

        showLoader();
        setDisplayName();

        showPage("configurations");
        updateSummaryMenuTotalPrice();

        initCollapsibles();

        seriesLibrary.fetchSeries();
    }

    let initCollapsibles = function () {

        /*@ts-ignore*/
        const bulmaCollapsibleInstances = bulmaCollapsible.attach('.is-collapsible');
    }

    //Login
    let handleLogin = function () {


        loggedIn = !!localStorage.getItem("accessToken");
        if (loggedIn) {

            var payload = CryptographyHelper.parseJwt(localStorage.getItem("accessToken"));
            var name = payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];
            var role = payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/role'];

            user = {
                name: name,
                role: role
            } as User;

            initApp();

        } else {
            showPage("login");
        }
    }

    let handleLogout = function () {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        user = null;
        window.location.reload();
    }

    let setDisplayName = function () {

        var userDisplayName = Y.one(".user-menu__label");
        userDisplayName.setHTML(user.name);
    }

    let cleanupAssets = function () {

        //Remove UI controls 
        if (GUI) {
            GUI.rootContainer.clearControls();
        }

        //Remove all meshes in module
        if (scene) {

            let modulesNode = scene.getNodeById("modules") as BABYLON.TransformNode;
            if (modulesNode) {

                const childMeshes = modulesNode.getChildMeshes(false);
                const childNodes = modulesNode.getChildTransformNodes(false);

                childMeshes.forEach(function (mesh) {
                    mesh.dispose(false, !mesh.isAnInstance);
                    mesh = null;
                });

                childNodes.forEach(function (node) {
                    node.dispose(false, false);
                    node = null;
                });
            }
        }
    }

    let resetMainCamera = function () {
        if (mainCamera) {
            mainCamera.alpha = Math.PI / 2;
            mainCamera.beta = Math.PI / 2.5;
            mainCamera.radius = 15;
        }
    }

    let initRenderer = async function () {

        return new Promise((resolve) => {
            canvas = document.getElementById("renderCanvas") as unknown as HTMLCanvasElement;
            engine = createEngine(canvas, scaleFactor);
            scene = createScene(engine);

            /*scene.onBeforeRenderObservable.add(function () {
                if (showMetrics) {
                    Metrics.UpdateRulers(scene, mainCamera);
                }
            }); */

            createEnvironment(scene);

            //  light = createLight("DirectionalLight", scene, new BABYLON.Vector3(66.3, 200, 21.7), new BABYLON.Vector3(-0.58, -0.96, -0.19), 1.5, -650, 650);

            light = createLight("DirectionalLight", scene, new BABYLON.Vector3(0, 0, 0), new BABYLON.Vector3(-0.38, -1, -0.38), 1.5, -5, 5);
            //light2 = createLight("DirectionalLight2", scene, new BABYLON.Vector3(-112, 3000, 124), new BABYLON.Vector3(0.25, -0.92, -0.29), 1, -200, 6500);

            sg = createShadowgenerator(light, 0.3, 0.15);
            // sg2 = createShadowgenerator(light2, 0.5, 0.25);

            ground = createGround(light, scene);
            // ground2 = createGround(light2, scene);

            GUI = BABYLON.GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI", true, scene, BABYLON.DynamicTexture.BILINEAR_SAMPLINGMODE);
            GUI.renderAtIdealSize = true;

            // rulerGUI = BABYLON.GUI.AdvancedDynamicTexture.CreateFullscreenUI("RulerUI", true, scene, BABYLON.DynamicTexture.BILINEAR_SAMPLINGMODE);

            rootNode = new BABYLON.TransformNode("root", scene);
            rootNode.position = BABYLON.Vector3.Zero();

            instanceNode = new BABYLON.TransformNode("instanceables", scene);

            modulesNode = new BABYLON.TransformNode("modules", scene);
            modulesNode.parent = rootNode;
            modulesNode.position = BABYLON.Vector3.Zero();

            productsNode = new BABYLON.TransformNode("products", scene);
            productsNode.parent = rootNode;

            meshLibrary.loadedMeshesNode = productsNode;
            meshLibrary.rootNode = modulesNode;
            meshLibrary.instanceNode = instanceNode;

            mainCamera = createMainCamera(scene);

            scene.activeCamera = mainCamera;
            mainCamera.attachControl(canvas, true, false);

            renderTargetCamera = createRenderTargetCamera(scene);
            //renderTargetCamera.attachControl(canvas, false, false);

            topviewCamera = createRenderTargetCamera(scene);

            /**
             * Scene pointer move (dragging etc.)
             * @param e
             */
            scene.onPointerMove = function (e) {
                if (currentEntityNode) {
                    if (isDragging) {

                        dragCanvas();

                        screenPointerPosition = new BABYLON.Vector2(scene.pointerX, scene.pointerY);
                        scenePointerPosition = getTargetPosition(screenPointerPosition.x, screenPointerPosition.y);
                        dragPosition = getZeroPlaneVector(mainCamera.position, scenePointerPosition);

                        //Move according to real center of entity
                        var centerNode = currentEntityNode.getChildTransformNodes(false, function (m) { return m.id === "center" })[0];
                        dragPosition.subtractInPlace(centerNode.position);

                        currentEntityNode.setAbsolutePosition(new BABYLON.Vector3(dragPosition.x, currentEntityNode.position.y, dragPosition.z));
                    }
                }
            };

            /**
             * Scene pointer up (stop drag etc.)
             * @param e
             */
            scene.onPointerUp = function (e) {
                if (isDragging) {
                    dragEndCanvas();
                    currentEntityNode = null;
                }
            };

            /**
             * Scene pointer down (click on scene, unselect meshes etc.)
             * @param e
             * @param pickInfo
             * @param type
             */
            scene.onPointerDown = function (e, pickInfo, type) {
                if (pickInfo.pickedMesh === null) {

                    if (isPlacing) {

                        if (currentEntityNode) {
                            screenPointerPosition = new BABYLON.Vector2(scene.pointerX, scene.pointerY);
                            scenePointerPosition = getTargetPosition(screenPointerPosition.x, screenPointerPosition.y);
                            dragPosition = getZeroPlaneVector(mainCamera.position, scenePointerPosition);

                            currentEntityNode.setAbsolutePosition(new BABYLON.Vector3(dragPosition.x, currentEntityNode.position.y, dragPosition.z));

                            let currentEntity = getCurrentEntity();

                            // let product = productLibrary.getProductByProductNo(currentEntity.productNo);
                            let productVariant = getProductVariant(currentEntity.productNo, currentEntity);

                            var entityBounds = currentEntityNode.getChildMeshes(true, function (m) { return m.id === "entitybounds" })[0];
                            entityBounds.setEnabled(true);

                            //Create legs
                            constructLegs(currentModule, currentEntity);

                            //Load entity mesh
                            meshLibrary.loadMeshAsync(productVariant.productNo, currentEntity, productVariant.type, "furniture/", productVariant.model + ".glb", productVariant.isFlipped, scene, false, sg, sg2, onProgress, function (clonedMeshEntityId, clonedMesh) {

                                // var clonedEntity = moduleHelper.getEntityByID(currentModule, clonedMeshEntityId);                           

                                //HACK! Rotate mesh if connection type CT11
                                //rotateCushions(entityConnectionType, currentEntity, clonedMesh, productVariant);

                                clonedMesh.scaling.x = productVariant.isFlipped ? -1 : 1;
                                clonedMesh.position.y = currentConfiguration.data.offsetY;

                                //Set material
                                let material = materialLibrary.getMaterialByProductNumber(currentConfiguration.data["material"]);
                                if (material) {
                                    materialLibrary.assignMaterial(Y, productVariant, [clonedMesh], material, scene, function () {
                                        clonedMesh.setEnabled(true);
                                    });
                                }

                            });
                        }

                        isPlacing = false;
                        hideAvailableConnectors();

                    } else {
                        hideHighlight(currentModuleNode);
                        hideEntityActions();
                        currentEntityNode = null;
                    }
                } else {

                    if (currentEntityNode) {
                        let entityNode = getParentMesh(pickInfo.pickedMesh, "entity") as BABYLON.Mesh;
                        if (entityNode.id === currentEntityNode.id) {

                            mainCamera.detachControl();
                            dragStartCanvas();

                            showHighlight(currentEntityNode);

                            screenPointerPosition = new BABYLON.Vector2(scene.pointerX, scene.pointerY);

                            scenePointerPosition = getTargetPosition(screenPointerPosition.x, screenPointerPosition.y);
                            dragPosition = getZeroPlaneVector(mainCamera.position, scenePointerPosition);

                            //Move according to real center of entity
                            var centerNode = currentEntityNode.getChildTransformNodes(false, function (m) { return m.id === "center" })[0];
                            dragPosition.subtractInPlace(centerNode.position);

                            currentEntityNode.setAbsolutePosition(new BABYLON.Vector3(dragPosition.x, currentEntityNode.position.y, dragPosition.z));
                        }
                    }

                }
            }

            /**
             * Scene pointer pick (picking meshes etc.)
             * @param e
             * @param pickInfo
             */
            scene.onPointerPick = function (e, pickInfo) {

                hideEntityActions();
                // currentEntityNode = null;

                if (e.button === 0) {
                    if (pickInfo.pickedMesh !== null) {

                        let mesh = pickInfo.pickedMesh;
                        let moduleNode = getParentMesh(mesh, "module") as BABYLON.TransformNode;
                        let module = currentConfiguration.data.modules.find(function (m) { return m.id === moduleNode.id });

                        currentModule = module;
                        currentModuleNode = moduleNode;

                        /* switch (viewMode) {
 
                             case "plan": {
 
                                 let moduleNode = getParentMesh(mesh, "module") as BABYLON.TransformNode;
 
                                 if (moduleNode) {
                                     hideEntityActions();
                                     enableAllProducts();
                                 }
                             }
                                 break;
                             case "module": {
                             */
                        if (isPlacing) {

                            isPlacing = false;

                            var entity = getCurrentEntity();
                            if (entity) {
                                deleteEntity(entity);
                            }

                            hideAvailableConnectors();

                        } else {

                            let entityNode = getParentMesh(mesh, "entity") as BABYLON.Mesh;
                            hideHighlight(moduleNode);

                            if (entityNode) {
                                currentEntityNode = entityNode;
                                showHighlight(entityNode);
                                showEntityActions();
                            }
                        }

                        /* }
                             break;
                     }*/
                    }
                }
            }

            //Pre-load antialias post-process effect
            // new BABYLON.FxaaPostProcess('antialiasing', 1.0, renderTargetCamera);

            /**
             * Renderlopp
             */
            engine.runRenderLoop(function () {
                if (render) {
                    scene.render();
                }
            });

            scene.executeWhenReady(function () {

                /**
                 * Renderer initialized
                 */
                rendererInitialized = true;
                resolve(true);
            });

        });
    }

    /*
     * Debug
     * */

    let enableDebug = function () {
        var keysPressed = {};

        document.addEventListener("keydown", function (event) {
            keysPressed[event.key] = true;

            if (keysPressed["Alt"]) {
                scene.debugLayer.show({
                    embedMode: true
                });
            }
        });
    };

    if (Y.config.debug) {
        enableDebug();
    };

    /*
     * Functions
     * */

    //let ioActivities = 0;

    let pauseRender = function () {
        render = false;
    }

    let isReady = function () {
        if (!scene.isReady()) return false;

        if (!light.isReady(true)) return false;

        for (let tex of scene.textures) {
            if (!tex.isReady()) return false;
        }

        for (let mesh of scene.meshes) {
            if (!mesh.isReady()) return false;
        }

        return true;
    }


    let resumeRender = async function () {

        let renderInterval;
        return new Promise(resolve => {
            renderInterval = setInterval(function () {
                if (isReady()) {
                    clearInterval(renderInterval);
                    render = true;
                    resolve(true);
                }
            }, 250);
        });
    }

    let showLoader = function () {
        let loader = Y.one(".loader-wrapper");
        loader.addClass("is-active");
    }

    let hideLoader = function () {
        let loader = Y.one(".loader-wrapper");
        loader.removeClass("is-active");
    }

    let showLoadingCanvas = function () {

        showLoader();

        let viewport = Y.one(".viewport");
        let loadCanvas = viewport.one("#loadCanvas");

        loadCanvas.addClass("is-active");
        viewport.addClass("is-loading");
        loadCanvas.getDOMNode().width = engine.getRenderWidth();
        loadCanvas.getDOMNode().height = engine.getRenderHeight();
        let freezeContext = loadCanvas.getDOMNode().getContext("2d");
        scene.render();
        freezeContext.drawImage(engine.getRenderingCanvas(), 0, 0, engine.getRenderWidth(), engine.getRenderHeight());

    }

    let showNotification = function (message: string) {

        let notification = Y.one(".notification");
        let notificationBody = notification.one(".notification-body");
        notificationBody.setHTML(message);
    }

    let hideLoadingCanvas = function () {

        let viewport = Y.one(".viewport");
        let loadCanvas = viewport.one("#loadCanvas");

        loadCanvas.addClass("is-fade");

        // Y.later(500, this, function () {
        loadCanvas.removeClass("is-active");
        loadCanvas.removeClass("is-fade");
        //Y.later(100, this, function () {
        viewport.removeClass("is-loading");
        //});
        hideLoader();
        // });
    }

    /* let toggleMetrics = function (show) {
 
         Metrics.ClearMetrics(scene, rulerGUI);
         if (show) {
             Metrics.CreateModuleRulers(currentModule, productLibrary, scene, rulerGUI);
         }
     }*/

    let createProjectConfiguration = function (project: Project, series: string) {

        let configuration = {
            series: series,
            data: {
                id: "configuration" + Date.now(),
                offsetY: 0,
                material: "",
                thumbnail: "",
                modules: [],
                options: {},
                customOptions: [{id: "Removable cover", value: "Removable cover"}]
            }
        } as Configuration;

        projectLibrary.createConfiguration(project, configuration);

        currentConfiguration = configuration;

    }

    let saveProjectConfiguration = function () {

        currentConfiguration.data.modules.forEach(function (module) {

            var moduleNode = scene.getTransformNodeByUniqueId(module.uniqueId);
            if (moduleNode) {
                module.position = moduleNode.position;
                module.rotation = moduleNode.rotation;
            }

            module.entities.forEach(function (entity) {

                var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
                if (entityNode) {
                    entity.position = entityNode.position;
                    entity.rotation = entityNode.rotation;
                }

            });

        });

        currentProject.configurations = currentProject.configurations.filter(x => x.data.id !== currentConfiguration.data.id);
        currentProject.configurations.push(currentConfiguration);

        projectLibrary.saveProject(currentProject);
    }

    let renderConfigurationThumbnail = async function (configuration: Configuration) {
        if (isReady()) {
            scene.executeWhenReady(() => {
                fitRenderTarget(currentModuleNode, renderTargetCamera);
                renderTargetCamera.update();

                //scene.render();

                BABYLON.Tools.CreateScreenshotUsingRenderTargetAsync(engine, renderTargetCamera, { width: 205, height: 115 }, "image/jpg", 1, true).then((data) => {
                    configuration.data.thumbnail = data;
                    window.dispatchEvent(new Event("thumbnail_rendered"));
                });
            });
        }
    }

    let renderConfigurationImage = (configuration: Configuration, callback: (image: string) => void, resolutionMultiplier: number = 1, alpha: number = Math.PI / 2, beta: number = (Math.PI / 2) * 0.97) => {

        if (isReady()) {
            scene.executeWhenReady(() => {
                fitRenderTarget(currentModuleNode, renderTargetCamera);
    
                renderTargetCamera.beta = beta;
                renderTargetCamera.alpha = alpha;
                renderTargetCamera.update();

                //scene.render();

                BABYLON.Tools.CreateScreenshotUsingRenderTargetAsync(engine, renderTargetCamera, { width: 1365 * resolutionMultiplier, height: 768 * resolutionMultiplier }, "image/jpg", 4, true).then((data) => {
                    callback(data);
                });
            });
        }
    }

    let renderConfigurationImages = (configuration: Configuration, callback?: () => void) => {
        renderConfigurationImage(configuration, (frontImage) => {
            renderConfigurationImage(configuration, (sideImage) => {
                renderConfigurationImage(configuration, (backImage) => {
                    FileSaver.saveAs(frontImage, currentConfiguration.series + "-front.png");
                    FileSaver.saveAs(sideImage, currentConfiguration.series + "-side.png");
                    FileSaver.saveAs(backImage, currentConfiguration.series + "-back.png");
                    if(callback){
                        callback();
                    }
                }, 3, Math.PI * 1.5);
            }, 3, Math.PI * 0.25);
        }, 3,  Math.PI * 0.5);
    }

    let renderDrawingWithGUI = (configuration: Configuration, callback: () => void) => {
        fitRenderTarget(currentModuleNode, topviewCamera);

        topviewCamera.beta = 0;
        topviewCamera.alpha = Math.PI / 2;
        topviewCamera.update();

        scene.executeWhenReady(() => {
            GUI.rootContainer.children.forEach(function (c) {
                if (c.name.indexOf("_label") >= 0) {
                    c.isVisible = true;
                }
            });

            scene.render();

            renderWithGUI((data) => {
                configuration.drawing = data;

                GUI.rootContainer.children.forEach(function (c) {
                    if (c.name.indexOf("_label") >= 0) {
                        c.isVisible = false;
                    }
                });

                callback();
            });
        });
    }

    let renderWithGUI = async function (successCallback: (data: any) => void) {

        const camera = topviewCamera;
        const width = 1500;
        const height = 1500;
        const antialiasing = true;
        let targetTextureSize = { width, height };

        if (!(height && width)) {
            BABYLON.Logger.Error("Invalid 'size' parameter !");
            return;
        }

        var save = engine.getAspectRatio;

        var scene = camera.getScene();
        var previousCamera = null;
        var previousCameras = scene.activeCameras;

        scene.activeCameras = null;

        if (scene.activeCamera !== camera) {
            previousCamera = scene.activeCamera;
            scene.activeCamera = camera;
        }

        engine.getAspectRatio = () => {
            return width / height;
        };

        GUI.scaleTo(width, height);
        GUI.markAsDirty();
        GUI.invalidateRect(0, 0, width - 1, height - 1);

        scene.render(); // make sure the scene is ready to be rendered in the RTT with the right list of active meshes (which depends on the camera, that may have been changed above)

        // At this point size can be a number, or an object (according to engine.prototype.createRenderTargetTexture method)
        var texture = new BABYLON.RenderTargetTexture("screenShot", targetTextureSize, scene, false, false, BABYLON.Constants.TEXTURETYPE_UNSIGNED_INT, false, BABYLON.Texture.NEAREST_SAMPLINGMODE, undefined, true, undefined, undefined, undefined, 1);
        texture.renderList = null;
        texture.samples = 1;
        texture.renderSprites = true;

        texture.onBeforeRenderObservable.add(() => {
        });

        texture.onAfterRenderObservable.add(() => {
            engine.setDepthBuffer(false);
            GUI.layer.render();
            engine.setDepthBuffer(true);
            //advancedTexture._onResize();
        });

        engine.onEndFrameObservable.addOnce(() => {
            const prom = texture.readPixels(undefined, undefined, undefined, false)

            prom.then((data) => {
                BABYLON.Tools.DumpData(width, height, data, successCallback, "image/jpg", null, true);
                texture.dispose();
            });
        });

        const renderToTexture = () => {
            // render the RTT
            scene.incrementRenderId();
            scene.resetCachedMaterial();
            texture.render(true);

            // re-render the scene after the camera has been reset to the original camera to avoid a flicker that could occur
            // if the camera used for the RTT rendering stays in effect for the next frame (and if that camera was different from the original camera)
            scene.incrementRenderId();
            scene.resetCachedMaterial();
            if (previousCamera) {
                scene.activeCamera = previousCamera;
            }
            scene.activeCameras = previousCameras;
            engine.getAspectRatio = save;
            camera.getProjectionMatrix(true); // Force cache refresh;
            scene.render();
        };

        if (antialiasing) {
            const fxaaPostProcess = new BABYLON.FxaaPostProcess('antialiasing', 1.0, scene.activeCamera);
            texture.addPostProcess(fxaaPostProcess);
            // Async Shader Compilation can lead to none ready effects in synchronous code
            if (!fxaaPostProcess.getEffect().isReady()) {
                fxaaPostProcess.getEffect().onCompiled = () => {
                    renderToTexture();
                };
            }
            // The effect is ready we can render
            else {
                renderToTexture();
            }
        }
        else {
            // No need to wait for extra resources to be ready
            renderToTexture();
        }
    }

    let toggleMeshVisibility = function (mesh: BABYLON.TransformNode, state: MeshVisibility) {

        if (mesh) {
            var childmeshes = mesh.getChildMeshes(false, function (m) { return !BABYLON.Tags.MatchesQuery(m, "connector") && !BABYLON.Tags.MatchesQuery(m, "entity")  });
            childmeshes.forEach(function (m, index) {

                if (m.isAnInstance)
                    return;

                switch (state) {

                    case MeshVisibility.VISIBLE: {
                        if (m.material) {
                            m.visibility = 1;
                            m.material.alpha = 1;
                            m.material.disableDepthWrite = false;
                            m.material.transparencyMode = 0;
                            m.material.alphaMode = 2;
                            m.material.needDepthPrePass = false;
                            m.renderingGroupId = 0;
                            m.setEnabled(true);
                        }
                    }
                        break;
                    case MeshVisibility.HIDDEN: {
                        if (m.material) {
                            m.visibility = 0;
                            m.material.alpha = 1;
                            m.material.disableDepthWrite = false;
                            m.material.transparencyMode = 0;
                            m.material.alphaMode = 0;
                            m.material.needDepthPrePass = false;
                            m.renderingGroupId = 0;
                            m.setEnabled(false);
                        }
                    }
                        break;
                    case MeshVisibility.HIGHLIGHTED: {
                        if (m.material) {
                            m.visibility = 1;
                            m.material.alpha = 1;
                            m.material.disableDepthWrite = false;
                            m.material.transparencyMode = 0;
                            m.material.alphaMode = 0;
                            m.material.needDepthPrePass = false;
                            m.renderingGroupId = 1;
                        }
                    }
                        break;
                    case MeshVisibility.FADED: {
                        if (m.material) {
                            m.renderingGroupId = 0;
                            m.material.alpha = 0.2;
                            m.material.disableDepthWrite = true;
                            m.material.transparencyMode = 1;
                            m.material.alphaMode = 7;
                            m.material.needDepthPrePass = true;
                        }
                    }
                        break;

                }

                m.updateCache(true);
            });
        }
    }

    let hideAllHighlights = function () {

        if (currentModule) {
            currentModule.entities.forEach(function (entity) {
                var entityNode = scene.getTransformNodeById(entity.id);
                hideHighlight(entityNode);
            });
        }
    }

    let hideAvailableConnectors = function () {

        if (currentModuleNode) {
            if (GUI.rootContainer.children.length > 0) {
                GUI.rootContainer.children.forEach(function (c) {
                    if (c.name.indexOf("_connector_") >= 0) {
                        c.alpha = 0;
                        c.isEnabled = false;
                    }
                });
            }

            var childmeshes = currentModuleNode.getChildMeshes(false, function (m) { return BABYLON.Tags.MatchesQuery(m, "connector") });
            childmeshes.forEach(function (m, index) {
                m.setEnabled(false);
            });
        }
    }


    let getCurrentEntity = function () {
        if (currentEntityNode) {
            return currentModule.entities.find(function (e) { return e.uniqueId === currentEntityNode.uniqueId });
        }
        return null;
    }

    let getAvailableConnectors = function (entity: Entity, availableEntity: Entity) {

        let availableConnectors = [] as Array<string>
        entity.connectors.forEach(function (connector: Connector) {
            availableConnectors.push(...getMatchingConnectors(connector, entity, availableEntity));

        });

        return availableConnectors.filter((value, index, self) => self.indexOf(value) === index);
    }

    let getMatchingConnectors = function (connector: Connector, parentEntity: Entity, childEntity: Entity) {

        let matchingConnectors = [] as Array<string>;

        switch (connector.id) {
            case "CT01_L": {
                matchingConnectors.push("CT04", "CT06", "CT10_R", "CT01_R");
            }
                break;
            case "CT01_R": {
                matchingConnectors.push("CT03", "CT05", "CT10_L", "CT01_L");
            }
                break;
            case "CT03":
            case "CT05":
            case "CT10_L": {
                matchingConnectors.push("CT04", "CT06", "CT10_R", "CT01_R");
            }
                break;
            case "CT04":
            case "CT06":
            case "CT10_R": {
                matchingConnectors.push("CT03", "CT05", "CT10_L", "CT01_L");
            }
                break;
            case "CT37": {
                matchingConnectors.push("CT11")
            }
        }

        return matchingConnectors;
    }

    let showAvailableConnectors = function (module: Module, entity: Entity) {

        hideAvailableConnectors();

        var traversedEntityIds = [];

        if (module) {
            if (entity) {

                //Iterate over all entities except current entity
                var availableEntities = module.entities.filter(function (e: Entity) {
                    return productLibrary.getProductCategory(e.category) === "UPHOLSTRY" &&
                        e.id !== entity.id &&
                        e.connectors.length > 0
                });

                availableEntities.forEach(function (availableEntity: Entity) {

                    let availableConnectors = getAvailableConnectors(entity, availableEntity);
                    availableConnectors.forEach(function (availableConnectorId: string) {

                        let availableEntityProduct = productLibrary.getProductByProductNo(availableEntity.productNo);

                        //TODO: Skal v�lges ud fra valgte cushionpackage i frontend
                        let availableEntityVariants = availableEntityProduct.cushionPackages[0].variants;

                        let entityConnection = availableEntity.connections.find(function (entityConnection: Connection) { return entityConnection.id === availableConnectorId });
                        let actionIcon = (!entityConnection) ? AppSettings.Paths.LinkIcon : AppSettings.Paths.InsertIcon;
                        let connectorEnabled = true;

                        //Disable if not part of connections
                        if (availableEntity.connections.length === 2) {
                            connectorEnabled = availableEntity.connections.map(con => con.id).includes(availableConnectorId);
                        }

                        if (entityConnection) {
                            //Deny entity to be inserted when we only have one connector
                            if (entity.connectors.length === 1) {
                                connectorEnabled = false;
                            }
                        }

                        if (availableEntity.category === "SOFA" &&
                            availableEntityVariants.filter(x => x.connectionType === "CT07").length === 0 &&
                            availableEntity.connections.length === 1) {
                            connectorEnabled = false;
                        }

                        var actionUIControl = GUI.rootContainer.getChildByName(module.id + "_" + availableEntity.id + "_connector_" + availableConnectorId) as BABYLON.GUI.Image;

                        //Create connection GUI elements                           
                        if (actionUIControl) {
                            actionUIControl.source = actionIcon;
                            actionUIControl.isEnabled = connectorEnabled;
                            actionUIControl.alpha = connectorEnabled ? 1 : 0;
                        }

                        //Enable connection mesh         
                        var entityNode = scene.getTransformNodeByUniqueId(availableEntity.uniqueId);
                        var connectorMesh = entityNode.getChildMeshes(false, function (m) { return m.name === availableConnectorId })[0];
                        if (connectorMesh) {
                            //   console.log(availableConnectorId + ": "+ connectorEnabled)
                            connectorMesh.setEnabled(connectorEnabled);
                        }

                    });

                    traversedEntityIds.push(availableEntity.id);
                })
            }
        }
    }

    let getPositionConnectorInfo = function (position: BABYLON.Vector2, mesh: BABYLON.TransformNode) {

        let connectorInfos = [] as Array<ConnectorInfo>;

        var ray = scene.createPickingRay(position.x, position.y, BABYLON.Matrix.Identity(), mainCamera);
        var pickingInfo: BABYLON.PickingInfo[] = scene.multiPickWithRay(ray, function (pickmesh) { return BABYLON.Tags.MatchesQuery(pickmesh, "connector") && pickmesh.parent !== mesh });

        pickingInfo.forEach(function (pi) {

            if (pi.pickedMesh) {

                var connectorMesh = pi.pickedMesh;
                let connectorInfo = {} as ConnectorInfo;
                connectorInfo.entityNode = connectorMesh.parent as BABYLON.AbstractMesh;
                connectorInfo.connectorNode = connectorMesh;
                connectorInfo.isEnabled = connectorMesh.isEnabled();
                connectorInfos.push(connectorInfo);

            }
        });

        return connectorInfos;
    }

    let setTargetRotation = function (
        parentNode: BABYLON.TransformNode,
        parentConnector: BABYLON.TransformNode,
        childNode: BABYLON.TransformNode,
        childConnector: BABYLON.TransformNode) {

        var parentRotation = BABYLON.Quaternion.Identity();
        parentConnector.getWorldMatrix().decompose(BABYLON.Vector3.Zero(), parentRotation, BABYLON.Vector3.Zero());

        var childRotation = BABYLON.Quaternion.Identity();
        childConnector.getWorldMatrix().decompose(BABYLON.Vector3.Zero(), childRotation, BABYLON.Vector3.Zero());

        let newRotationAngle = MathHelper.normalizePi((parentRotation.toEulerAngles().y - childRotation.toEulerAngles().y));
        let newRotation = new BABYLON.Vector3(0, newRotationAngle, 0);

        targetRotation = childNode.rotation.add(newRotation);
        childNode.computeWorldMatrix(true);
    }

    let animateRotation = function (node, targetRotation) {
        animRotation = BABYLON.Animation.CreateAndStartAnimation("animRotate", node, "rotation", 60, 30, node.rotation, targetRotation, BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT, easingFunction);
    }

    let moveEntity = function (
        parentNode: BABYLON.TransformNode,
        parentConnector: BABYLON.TransformNode,
        childNode: BABYLON.TransformNode,
        childConnector: BABYLON.TransformNode) {

        parentNode.computeWorldMatrix(true);
        parentConnector.computeWorldMatrix(true);
        childConnector.computeWorldMatrix(true);

        var parentRotation = BABYLON.Quaternion.Identity();
        parentConnector.getWorldMatrix().decompose(BABYLON.Vector3.Zero(), parentRotation, BABYLON.Vector3.Zero());

        var childRotation = BABYLON.Quaternion.Identity();
        childConnector.getWorldMatrix().decompose(BABYLON.Vector3.Zero(), childRotation, BABYLON.Vector3.Zero());

        let newRotationAngle = MathHelper.normalizePi((parentRotation.toEulerAngles().y - childRotation.toEulerAngles().y));
        let newRotation = new BABYLON.Vector3(0, newRotationAngle, 0);

        childNode.rotation.addInPlace(newRotation);
        childConnector.computeWorldMatrix(true);

        var positionDiff = parentConnector.getAbsolutePosition().subtract(childConnector.getAbsolutePosition());
        childNode.position = childNode.position.add(positionDiff);
        childNode.computeWorldMatrix(true);
    }

    let connectEntities = function (
        parentNode: BABYLON.TransformNode,
        parentConnector: BABYLON.TransformNode,
        childNode: BABYLON.TransformNode,
        childConnector: BABYLON.TransformNode) {

        var parentEntity = moduleHelper.getEntityByID(currentModule, parentNode.id);
        var childEntity = moduleHelper.getEntityByID(currentModule, childNode.id);

        if (childEntity) {
            var childConnection = childEntity.connections.find(function (c) { return c.id === childConnector.name });
            if (childConnection) {
                var index = childEntity.connections.indexOf(childConnection);
                childEntity.connections.splice(index, 1);
            }

            if (parentEntity) {
                childEntity.connections.push({ id: childConnector.name, entityId: parentEntity.id });
            }
        }

        if (parentEntity) {
            var parentConnection = parentEntity.connections.find(function (c) { return c.id === parentConnector.name });
            if (parentConnection) {
                var index = parentEntity.connections.indexOf(parentConnection);
                parentEntity.connections.splice(index, 1);
            }

            if (childEntity) {
                parentEntity.connections.push({ id: parentConnector.name, entityId: childEntity.id });
            }
        }
    }

    let instantiateModule = function (configuration: Configuration, module?: Module, callback?: ModuleCreateCallback) {

        let moduleNode: BABYLON.TransformNode = null;

        if (!module) {

            module = {} as Module;
            module.id = "module" + Date.now();
            module.position = BABYLON.Vector3.Zero();
            module.rotation = BABYLON.Vector3.Zero();
            module.entities = [];

            configuration.data.modules.push(module);
        }

        moduleNode = scene.getTransformNodeByUniqueId(module.uniqueId);
        if (!moduleNode) {
            moduleNode = new BABYLON.TransformNode(module.id, scene);
            module.uniqueId = moduleNode.uniqueId;
            BABYLON.Tags.AddTagsTo(moduleNode, "module");
        }

        moduleNode.position = new BABYLON.Vector3(module.position._x, module.position._y, module.position._z);
        moduleNode.rotation = new BABYLON.Vector3(module.rotation._x, module.rotation._y, module.rotation._z);
        moduleNode.parent = modulesNode;
        moduleNode.computeWorldMatrix(true);

        if (callback) {
            callback(module, moduleNode);
        }

        return { module, moduleNode }
    }

    let instantiateEntity = function (
        module: Module,
        product: Product,
        entity?: Entity,
        callback?: EntityCreateCallback) {

        var moduleNode = scene.getTransformNodeByUniqueId(module.uniqueId);

        if (!entity) {

            entity = {} as Entity;
            entity.id = "entity" + Date.now();
            entity.connections = [];
            entity.connectors = [];
            entity.position = BABYLON.Vector3.Zero();
            entity.rotation = BABYLON.Vector3.Zero();
            entity.productNo = product.productNo;
            entity.parentId = moduleNode.id;
            entity.category = product.type;

            module.entities.push(entity);
        }

        // entity.rotation = BABYLON.Vector3.Zero();

        //Entity node
        let entityNode = new BABYLON.TransformNode(entity.id, scene);
        entity.uniqueId = entityNode.uniqueId;
        entityNode.metadata = {};
        entityNode.metadata.productNo = entity.productNo;
        entityNode.rotation = BABYLON.Vector3.Zero();

        entityNode.computeWorldMatrix(true);

        var entityAttachNode = null;
        if (entity.attachId) {
            var parentNode = scene.getNodeById(entity.parentId);
            entityAttachNode = parentNode.getChildren(function (c) { return c.id === entity.attachId }, false)[0];
        } else {
            entityAttachNode = moduleNode;
        }

        entityNode.parent = entityAttachNode;

        BABYLON.Tags.EnableFor(entityNode);
        BABYLON.Tags.AddTagsTo(entityNode, "entity");

        //Entitybounds
        var entityBounds = BABYLON.MeshBuilder.CreateBox("entitybounds", {
            width: ConversionHelper.scale(product.width, scaleFactor) as number,
            height: ConversionHelper.scale(product.height, scaleFactor) as number,
            depth: ConversionHelper.scale(product.depth, scaleFactor) as number
        }, scene);
        var entityExtendSize = entityBounds.getBoundingInfo().boundingBox.extendSize;
        entityBounds.position.addInPlace(new BABYLON.Vector3(0, 0, entityExtendSize.z));

        entityBounds.parent = entityNode;
        entityBounds.visibility = 0.5;
        entityBounds.isPickable = false;
        entityBounds.setEnabled(false);

        entityBounds.setPivotMatrix(BABYLON.Matrix.Translation(0, entityBounds.getBoundingInfo().boundingBox.extendSize.y, 0), false);
        entityNode.setPivotPoint(entityBounds.position, BABYLON.Space.LOCAL);
        entityNode.computeWorldMatrix(true);

        BABYLON.Tags.EnableFor(entityBounds);
        BABYLON.Tags.AddTagsTo(entityBounds, "entitybounds");

        if (productLibrary.getProductCategory(entity.category) === "UPHOLSTRY") {

            //Create center
            createCenter(module, entity, scene);

            //Create actions for entity
            createEntityActions(module, entity, scene, product);

            //Create connectors for entity           
            createEntityConnectors(module, entity, product, scene);

            //Create weights to determine best view 
            createEntityWeights(entity);

            //Create leg attachments
            createLegAttachments(module, entity, product, scene);
        }

        entityNode.position = ConversionHelper.toVector3(entity.position);
        entityNode.rotation = ConversionHelper.toVector3(entity.rotation);

        if (callback) {
            callback(entity, entityNode, entity.productNo);
        }

        return { entity, entityNode }
    }

    let createFreestandingAttachments = function (entity: Entity, entityNode: BABYLON.TransformNode, positionX: number, positionZ: number, offsetX: number, offsetZ: number) {

        createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), BABYLON.Vector3.One());
        createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
        createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
        createAttachmentPoint("right_front", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
    }

    let createLegAttachments = function (module: Module, entity: Entity, product: Product, scene: BABYLON.Scene) {

        var entityConnectionType = moduleHelper.getEntityConnectionType(module, entity);
        var seriesDepth = ConversionHelper.scale(getSeriesDepth(), scaleFactor) as number;
        var series = seriesLibrary.getSeriesById(product.series);

        var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
        if (entityNode) {

            var entityBounds = entityNode.getChildMeshes(true, function (m) { return m.id === "entitybounds" })[0];
            var bv = entityBounds.getHierarchyBoundingVectors();
            var bb = new BABYLON.BoundingBox(bv.min, bv.max);

            var offsetX = 0;
            var offsetZ = 0;

            var positionX = bb.extendSize.x;
            var positionZ = (bb.extendSize.z * 2);

            //Has connections! 
            switch (entity.category) {

                case "CENTER_SECTION":
                case "CENTER_SECTION_LEFT_SHORTBACK":
                case "CENTER_SECTION_RIGHT_SHORTBACK": {

                    switch (entityConnectionType) {
                        case "CT00": {
                            createFreestandingAttachments(entity, entityNode, positionX, positionZ, offsetX, offsetZ);
                        }
                            break;
                        case "CT02": {
                            createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), BABYLON.Vector3.One());
                        }
                            break;
                        case "CT03": {
                            createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                        }
                            break;
                        case "CT04": {
                            createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), BABYLON.Vector3.One());
                            createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                            createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                        }
                            break;
                    }

                }
                    break;
                case "CORNER_SECTION": {

                    let cornerLegType = series.legPackages.filter(x => x.type === "LT03").length > 0 ? "LT03" : "LT01"

                    switch (entityConnectionType) {
                        case "CT10":
                        case "CT10_L":
                        case "CT10_R": {
                            createAttachmentPoint("left_back", `leg ${cornerLegType}`, entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                            createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, seriesDepth - offsetZ), BABYLON.Vector3.Zero(), BABYLON.Vector3.One());
                        }
                            break;
                    }

                }
                    break;
                case "CLOSING_SECTION_LEFT":
                case "CLOSING_SECTION_LEFT_SHORTBACK": {

                    switch (entityConnectionType) {
                        case "CT00": {
                            createFreestandingAttachments(entity, entityNode, positionX, positionZ, offsetX, offsetZ);
                        }
                            break;
                        case "CT01": {
                            createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), BABYLON.Vector3.One());
                            createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                            createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), MathHelper.getRotationVector(Math.PI, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                            createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(0, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                        }
                            break;
                        case "CT05": {
                            createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                            createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                        }
                            break;
                        case "CT08": {
                            createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                            createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), MathHelper.getRotationVector(Math.PI, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                            createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(0, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                        }
                            break;
                    }

                }
                    break;
                case "CLOSING_SECTION_RIGHT":
                case "CLOSING_SECTION_RIGHT_SHORTBACK": {
                    switch (entityConnectionType) {
                        case "CT00": {
                            createFreestandingAttachments(entity, entityNode, positionX, positionZ, offsetX, offsetZ);
                        }
                            break;
                        case "CT01": {
                            createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                        }
                            break;
                        case "CT06": {
                            createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), BABYLON.Vector3.One());
                            createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                            createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(-Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                            createAttachmentPoint("middle_front", "leg lt02", entityNode, new BABYLON.Vector3((seriesDepth - positionX) - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                        }
                            break;
                        case "CT09": {
                            createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(-Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                            createAttachmentPoint("left_front", "leg lt02", entityNode, new BABYLON.Vector3((seriesDepth - positionX) - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                        }
                            break;
                    }
                }
                    break;
                case "SOFA": {
                    switch (entityConnectionType) {
                        case "CT00": {
                            createFreestandingAttachments(entity, entityNode, positionX, positionZ, offsetX, offsetZ);
                        }
                            break;
                        case "CT05": {
                            createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                            createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                        }
                            break;
                        case "CT06": {
                            createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), BABYLON.Vector3.One());
                            createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                            createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(-Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                            createAttachmentPoint("middle_front", "leg lt02", entityNode, new BABYLON.Vector3((seriesDepth - positionX) - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                        }
                            break;
                        case "CT07": {
                            createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                            createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(-Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                            createAttachmentPoint("middle_front", "leg lt02", entityNode, new BABYLON.Vector3((seriesDepth - positionX) - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                        }
                            break;
                    }
                }
                    break;
                case "FOOTSTOOL": {
                    switch (entityConnectionType) {
                        case "CT00": {

                            if (product.width >= product.depth && product.width <= seriesDepth) {
                                createFreestandingAttachments(entity, entityNode, positionX, positionZ, offsetX, offsetZ);
                            } else {
                                createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(-1, 1, 1));
                                createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(1, 1, 1));
                                createAttachmentPoint("right_front", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(1, 1, -1));
                                createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(-1, 1, -1));
                            }
                        }
                            break;
                        case "CT02": {
                            createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, seriesDepth - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                        }
                            break;
                        case "CT03": {
                            createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, seriesDepth - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                        }
                            break;
                        case "CT04": {
                            createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, seriesDepth - offsetZ), BABYLON.Vector3.Zero(), BABYLON.Vector3.One());
                            createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                            createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, seriesDepth - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                        }
                            break;
                        case "CT11": {
                            if (product.width !== product.depth) {
                                if (entity.connections.map(x => x.id).includes("CT03")) {
                                    createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                                    createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                                } else {
                                    /* createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, seriesDepth - offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(-1, 1, 1));
                                    createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                                    createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                                    createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, seriesDepth - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));*/
                                    createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), BABYLON.Vector3.One());
                                    createAttachmentPoint("left_back", "leg lt02", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), MathHelper.getRotationVector(-Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(1, 1, -1));
                                    createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), MathHelper.getRotationVector(-Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                                    createAttachmentPoint("right_front", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                                }
                            } else {
                                if (entity.connections.map(x => x.id).includes("CT03")) {
                                    createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(1, 1, -1));
                                    createAttachmentPoint("right_front", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, seriesDepth - offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(-1, 1, -1));
                                } else {
                                    createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, seriesDepth - offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(-1, 1, 1));
                                    createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                                    createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                                    createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, seriesDepth - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));

                                }

                            }
                        }
                            break;
                    }
                }
                    break;
                case "ARM": {

                }
                    break;
                case "SEATFRAME": {

                }
                    break;
            }
        }
    }

    let createAttachmentPoint = function (id: string, tags: string, parent: BABYLON.TransformNode | BABYLON.AbstractMesh, position: BABYLON.Vector3, rotation: BABYLON.Vector3, scaling: BABYLON.Vector3): BABYLON.TransformNode {

        let attachmentNode = new BABYLON.TransformNode(parent.id + "_attachment_" + id, scene);

        attachmentNode.parent = parent;
        attachmentNode.rotation = rotation;
        attachmentNode.position = position;
        attachmentNode.scaling = scaling;

        BABYLON.Tags.EnableFor(attachmentNode);
        BABYLON.Tags.AddTagsTo(attachmentNode, tags);

        return attachmentNode;
    }

    let createEntityWeights = function (entity: Entity) {

        var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
        if (entityNode) {

            var entityBounds = entityNode.getChildMeshes(true, function (m) { return m.id === "entitybounds" })[0];
            var bv = entityBounds.getHierarchyBoundingVectors();
            var bb = new BABYLON.BoundingBox(bv.min, bv.max);

            let offset = ConversionHelper.scale(30, scaleFactor) as number;

            var weightPosition = bb.center.subtract(new BABYLON.Vector3(0, 0, offset));

            //TODO - Needs to be part of model
            if (bb.extendSize.x / bb.extendSize.z === 1) {
                weightPosition = bb.center.subtract(new BABYLON.Vector3(offset, 0, offset));
            }

            var weight = BABYLON.MeshBuilder.CreateBox("weight", { size: 10 * scaleFactor }, scene);
            weight.setEnabled(false);
            weight.parent = entityNode;
            weight.position = weightPosition;

        }
    }

    let getParentMesh = function (mesh: BABYLON.Node, tags?: string): BABYLON.Node {

        if (BABYLON.Tags.HasTags(mesh.parent)) {
            if (BABYLON.Tags.MatchesQuery(mesh.parent, tags)) {
                return mesh.parent;
            }
        }

        return getParentMesh(mesh.parent, tags);
    }

    let createActionButton = function (module: Module, entity: Entity, name: string, textureUrl: string, onPointerDown: any, onPointerUp: any) {

        var actionButton = new BABYLON.GUI.Image(module.id + "_" + entity.id + "_" + name, textureUrl);
        actionButton.paddingBottom = "2px";
        actionButton.paddingLeft = "2px";
        actionButton.paddingTop = "2px";
        actionButton.paddingRight = "2px";
        actionButton.width = "48px";
        actionButton.height = "48px";
        actionButton.metadata = {};
        actionButton.metadata.entityId = entity.id;
        actionButton.isEnabled = true;
        actionButton.isPointerBlocker = true;
        actionButton.alpha = 0.6;
        actionButton.onPointerEnterObservable.add(function (e, ec) {
            actionButton.alpha = 1;
        });
        actionButton.onPointerOutObservable.add(function (e, ec) {
            actionButton.alpha = 0.6;
        });
        actionButton.onPointerUpObservable.add(function (e, ec) {
            actionButton.alpha = 0.6;

            if (typeof (onPointerUp) === "function") {
                onPointerUp(e, ec);
            }
        });
        actionButton.onPointerDownObservable.add(function (e, ec) {
            actionButton.alpha = 1;
            if (typeof (onPointerDown) === "function") {
                onPointerDown(e, ec);
            }
        });
        return actionButton;

    }

    var createProgressBar = function (module, entity) {

        var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
        var entityBounds = entityNode.getChildMeshes(true, function (m) { return m.id === "entitybounds"; })[0];

        var progressbg = new BABYLON.GUI.Rectangle(module.id + "_" + entity.id + "_progressbg");
        progressbg.width = "100px";
        progressbg.height = "12px";
        progressbg.color = "Gray";
        // progressbg.thickness = 2;
        progressbg.background = "Gray";
        progressbg.alpha = 0.6;

        var progresspct = new BABYLON.GUI.Rectangle(module.id + "_" + entity.id + "_progresspct");
        progresspct.width = "0px";
        progresspct.height = "12px";
        progresspct.color = "Gray";
        // progresspct.thickness = 2;
        progresspct.background = "Gray";

        GUI.addControl(progressbg);
        GUI.addControl(progresspct);

        progressbg.linkWithMesh(entityBounds);
        progresspct.linkWithMesh(entityBounds);

        return progressbg;
    }

    let createCenter = function (module: Module, entity: Entity, scene: BABYLON.Scene) {

        var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
        if (entityNode) {
            var entityBounds = entityNode.getChildMeshes(true, function (m) { return m.id === "entitybounds" })[0];
            var entityExtendSize = entityBounds.getBoundingInfo().boundingBox.extendSize;

            var centerNode = new BABYLON.TransformNode("center", scene);
            centerNode.parent = entityNode;
            centerNode.position.addInPlace(new BABYLON.Vector3(0, 0, entityExtendSize.z));
            centerNode.computeWorldMatrix(true);
        }
    }

    let createEntityActions = function (module: Module, entity: Entity, scene: BABYLON.Scene, product: Product) {

        var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
        if (entityNode) {

            var actionContainer = new BABYLON.GUI.StackPanel(module.id + "_" + entity.id + "_actionContainer");
            actionContainer.isVertical = false;

            //Rotate action
            let actionRotateButton = createActionButton(module, entity, "action_rotate", AppSettings.Paths.RotateIcon, function (e, ec) {

                var entityId = ec.target.metadata.entityId;
                var entity = moduleHelper.getEntityByID(module, entityId);// currentModule.entities.find(function (e) { return e.id === entityId });

                removeEntityConnections(entity);

                entity.rotation.y += Math.PI / 2;

                currentConnector = null;
                currentEntityNode = null;

                constructModule(currentModule);

            }, null);
            actionContainer.addControl(actionRotateButton);

            //Delete action
            let actionDeleteButton = createActionButton(module, entity, "action_delete", AppSettings.Paths.DeleteIcon, function (e, ec) {

                var entityId = ec.target.metadata.entityId;
                var entity = moduleHelper.getEntityByID(module, entityId);

                hideEntityActions();
                deleteEntity(entity);

                constructModule(currentModule);

            }, null);
            actionContainer.addControl(actionDeleteButton);

            GUI.addControl(actionContainer);

            var centerNode = entityNode.getChildTransformNodes(true, function (t) { return t.id === "center" })[0];
            actionContainer.linkWithMesh(centerNode);

            var labelContainer = new BABYLON.GUI.Rectangle(module.id + "_" + entity.id + "_label");
            labelContainer.width = "220px";
            labelContainer.height = "52px";
            labelContainer.cornerRadius = 4;
            labelContainer.color = "black";
            labelContainer.thickness = 1;
            labelContainer.background = "white";
            GUI.addControl(labelContainer);
            labelContainer.linkWithMesh(centerNode);
            labelContainer.linkOffsetY = -16;

            labelContainer.isVisible = false;

            var productVariant = productLibrary.getProductVariantByConnectionType(product, moduleHelper.getEntityConnectionType(module, entity));

            var text1 = new BABYLON.GUI.TextBlock(module.id + "_" + entity.id + "_productNo");
            text1.text = product.productNo.replace("/", "/\r\n") + "\r\n" + productVariant.axProductNo;
            text1.color = "black";
            text1.fontSize = 14;
            labelContainer.addControl(text1);
        }
    }

    let detectCircular = function (entityId: string) {

        let traversed = [] as Array<string>;

        //Detect
        let detect = function (entityId: string, previousId: string) {

            if (entityId) {

                var entity = moduleHelper.getEntityByID(currentModule, entityId);
                if (entity) {

                    if (traversed.indexOf(entityId) !== -1) {
                        return true;
                    }

                    traversed.push(entityId);

                    let filteredConnections = entity.connections.filter(function (e) { return e.entityId != previousId });

                    for (var i = 0; i < filteredConnections.length; i++) {

                        var connectedEntity = moduleHelper.getEntityByID(currentModule, filteredConnections[i].entityId);
                        if (connectedEntity) {
                            if (detect(connectedEntity.id, entityId)) {
                                return true;
                            }
                        }
                    }
                }
                return false;
            }
        }
        return detect(entityId, null);
    }

    let getConnectedConnectorInfo = function (entity: Entity) {

        let connectors = [];

        let entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
        if (entityNode) {

            //Iterate entity connections
            entity.connections.forEach(function (cn) {

                let connectedEntity = moduleHelper.getEntityByID(currentModule, cn.entityId) as Entity;
                if (connectedEntity) {

                    //Connected entity node
                    let connectedEntityNode = scene.getTransformNodeByUniqueId(connectedEntity.uniqueId);
                    var connectedEntityConnection = connectedEntity.connections.find(c => { return c.entityId === entity.id });
                    if (connectedEntityConnection) {
                        var connectedEntityConnector = connectedEntity.connectors.find(c => { return c.id === connectedEntityConnection.id });
                        var connectedEntityConnectorNode = connectedEntityNode.getChildMeshes(true, function (childNode) { return childNode.name === connectedEntityConnector.id })[0];
                        connectors.push({ mesh: connectedEntityNode, connector: connectedEntityConnectorNode, weight: 0 });
                    }
                }
            });
        }

        return connectors;
    }

    let moveConnectedEntities = function (entity: Entity, traversedIds: Array<string>) {

        if (!traversedIds.includes(entity.id)) {

            traversedIds.push(entity.id);

            entity.connections.forEach(function (connection) {

                let entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
                if (entityNode) {
                    let entityConnectorNode = entityNode.getChildMeshes(true, function (c) { return c.name === connection?.id })[0];

                    var connectedEntity = moduleHelper.getEntityByID(currentModule, connection?.entityId);
                    let connectedEntityNode = scene.getTransformNodeByUniqueId(connectedEntity?.uniqueId ?? 0);
                    if (connectedEntityNode) {
                        var connectedEntityConnection = connectedEntity.connections.find(c => { return c.entityId === (entity?.id ?? 0)});
                        var connectedEntityConnector = connectedEntity.connectors.find(c => { return c.id === (connectedEntityConnection?.id ?? 0)});                
                        var connectedEntityConnectorNode = connectedEntityNode.getChildMeshes(true, function (childNode) { return childNode.name === (connectedEntityConnector?.id ?? 0)})[0];

                        if (connectedEntityConnectorNode) {
                            moveEntity(entityNode, entityConnectorNode, connectedEntityNode, connectedEntityConnectorNode);
                            moveConnectedEntities(connectedEntity, traversedIds);
                        }
                    }
                }
            });
        }
    }

    let moveAllEntities = function (module: Module) {

        let traversedIds = [] as Array<string>;

        module.entities.filter(e => e.parentId === module.id).forEach(function (entity) {
            if (!traversedIds.includes(entity.id)) {

                traversedIds.push(entity.id);

                entity.connections.forEach(function (connection) {

                    let entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
                    let entityConnectorNode = entityNode.getChildMeshes(true, function (c) { return c.name === connection.id })[0];

                    var connectedEntity = moduleHelper.getEntityByID(module, connection.entityId);
                    if (connectedEntity) {
                        let connectedEntityNode = scene.getTransformNodeByUniqueId(connectedEntity.uniqueId);
                        if (connectedEntityNode) {
                            var connectedEntityConnection = connectedEntity.connections.find(c => { return c.entityId === entity.id });
                            if (connectedEntityConnection) {
                                var connectedEntityConnector = connectedEntity.connectors.find(c => { return c.id === connectedEntityConnection.id });
                                var connectedEntityConnectorNode = connectedEntityNode.getChildMeshes(true, function (childNode) { return childNode.name === connectedEntityConnector.id })[0];

                                moveEntity(entityNode, entityConnectorNode, connectedEntityNode, connectedEntityConnectorNode);
                                moveConnectedEntities(connectedEntity, traversedIds);
                            }
                        }
                    }
                });
            }
        });

    }

    let deleteEntity = function (entity: Entity) {

        let connectors = [];

        let entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
        if (entityNode) {

            cleanupResources(entityNode);

            //Are entities connected in a circular loop?
            let isCircular = detectCircular(entity.id);

            //Get connected connectorinfos
            connectors = getConnectedConnectorInfo(entity);
            if (connectors.length === 2 && !isCircular) {
                connectEntities(connectors[0].mesh, connectors[0].connector, connectors[1].mesh, connectors[1].connector);
                var connectedEntity = moduleHelper.getEntityByID(currentModule, connectors[0].mesh.id);
                moveConnectedEntities(connectedEntity, []);
            }

            //Remove entity connections
            removeEntityConnections(entity);

            //Dispose child entities
            var disposableEntities = currentModule.entities.filter(function (e) { return e.parentId === entity.id });
            disposableEntities.forEach(function (c) {
                deleteEntity(c);
            });

            //Dispose UI controls
            /*var disposableControls = GUI.rootContainer.children.filter(function (c) { return c.name.indexOf(currentModule.id + "_" + entity.id) >= 0 });
            for (var c = 0; c < disposableControls.length; c++) {
                let control = disposableControls[c];
                control.dispose();
            }*/

            entityNode.dispose();
            currentEntityNode = null;
            currentConnector = null;

            //Remove entity from module
            let index = currentModule.entities.indexOf(entity);
            currentModule.entities.splice(index, 1);

        }
    }

    let cleanupResources = function (mesh: BABYLON.TransformNode | BABYLON.AbstractMesh) {

        if (mesh instanceof BABYLON.AbstractMesh && !mesh.isAnInstance) {
            if (mesh.material) {
                mesh.material.dispose(true, true);
                mesh.material = null;
            }
        }

        mesh.getChildTransformNodes(false).forEach(function (t) {
            cleanupResources(t);
        });

        mesh.getChildMeshes(false).forEach(function (m) {
            cleanupResources(m);
        });

    }

    let showEntityActions = function () {

        GUI.rootContainer.children.forEach(function (c) {

            if (currentEntityNode) {
                if (c.name.indexOf(currentModuleNode.id + "_" + currentEntityNode.id + "_actionContainer") >= 0) {
                    c.isVisible = true;
                }
            }
        });
    }

    let hideEntityActions = function () {

        GUI.rootContainer.children.forEach(function (c) {
            if (c.name.indexOf("_actionContainer") >= 0) {
                c.isVisible = false;
            }
        });
    }

    let getSeriesDepth = function () {

        var seriesDepth = 0;

        var products = productLibrary.productsCategories.filter(function (p) { return productLibrary.getProductCategory(p.type) === "UPHOLSTRY" }).flatMap(function (p) { return p.products });
        var depths = products.map(function (p: Product) { return p.depth });

        seriesDepth = depths.reduce(
            (acc, item) =>
                depths.filter((v) => v === acc).length >=
                    depths.filter((v) => v === item).length
                    ? acc
                    : item,
            null
        );

        return seriesDepth;
    }

    let createEntityConnectors = function (module: Module, entity: Entity, product: Product, scene: BABYLON.Scene) {

        var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
        var entityBounds = entityNode.getChildMeshes(true, function (cm) { return cm.id === "entitybounds" })[0];

        //Clear connectors
        var connectorNodes = entityNode.getChildMeshes(false, function (c) { return BABYLON.Tags.MatchesQuery(c, "connector") });
        connectorNodes.forEach(function (cn, index) {
            cn.dispose();
            cn = null;
        });
        entity.connectors = [];

        if (entityNode) {

            let entityConnectionType = moduleHelper.getEntityConnectionType(module, entity);
            let entityBoundingBox = entityBounds.getBoundingInfo().boundingBox;

            var entityWidth = ConversionHelper.scale(product.width, scaleFactor) as number;
            var entityDepth = ConversionHelper.scale(product.depth, scaleFactor) as number;
            let seriesDepth = ConversionHelper.scale(getSeriesDepth(), scaleFactor) as number;

            switch (entity.category) {

                case "CENTER_SECTION":
                case "CENTER_SECTION_LEFT_SHORTBACK":
                case "CENTER_SECTION_RIGHT_SHORTBACK":
                case "CHAISELONG_NOARM": {

                    if (productLibrary.hasProductVariants(product, ["CT04", "CT02"])) {
                        createEntityConnector(module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityBoundingBox.extendSize.x, 0, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT03", "CT02"])) {
                        createEntityConnector(module, entity, entityNode, "CT03", new BABYLON.Vector3(entityBoundingBox.extendSize.x, 0, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }

                }
                    break;
                case "FOOTSTOOL": {

                    if (productLibrary.hasProductVariants(product, ["CT04", "CT03"])) {
                        var depth = 0;

                        if (entityWidth >= entityDepth) {

                            if (entityDepth < seriesDepth) {

                                depth = (entityWidth - seriesDepth) / 2;

                                createEntityConnector(module, entity, entityNode, "CT04", new BABYLON.Vector3(depth, 0, 0), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                                createEntityConnector(module, entity, entityNode, "CT03", new BABYLON.Vector3(depth, 0, entityDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                            } else {

                                depth = (entityDepth - seriesDepth) / 2;

                                createEntityConnector(module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityBoundingBox.extendSize.x, 0, entityBoundingBox.extendSize.z - depth), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                                createEntityConnector(module, entity, entityNode, "CT03", new BABYLON.Vector3(entityBoundingBox.extendSize.x, 0, entityBoundingBox.extendSize.z - depth), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                            }
                        } else {

                            if (entityWidth < seriesDepth) {

                                depth = (entityDepth - seriesDepth) / 2;

                                createEntityConnector(module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityBoundingBox.extendSize.x, 0, entityBoundingBox.extendSize.z - depth), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                                createEntityConnector(module, entity, entityNode, "CT03", new BABYLON.Vector3(entityBoundingBox.extendSize.x, 0, entityBoundingBox.extendSize.z - depth), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                            } else {

                                depth = (entityWidth - seriesDepth) / 2;

                                createEntityConnector(module, entity, entityNode, "CT04", new BABYLON.Vector3(depth, 0, 0), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                                createEntityConnector(module, entity, entityNode, "CT03", new BABYLON.Vector3(depth, 0, entityDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);

                            }
                        }
                    }
                }
                    break;
                case "CLOSING_SECTION_LEFT":
                case "CLOSING_SECTION_LEFT_SHORTBACK": {

                    if (productLibrary.hasProductVariants(product, ["CT01", "CT08"])) {
                        createEntityConnector(module, entity, entityNode, "CT01_R", new BABYLON.Vector3(-entityBoundingBox.extendSize.x, 0, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT05", "CT08"])) {
                        createEntityConnector(module, entity, entityNode, "CT05", new BABYLON.Vector3(entityBoundingBox.extendSize.x - (seriesDepth / 2), 0, seriesDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                    }

                }
                    break;
                case "CLOSING_SECTION_RIGHT":
                case "CLOSING_SECTION_RIGHT_SHORTBACK": {

                    if (productLibrary.hasProductVariants(product, ["CT06", "CT09"])) {
                        createEntityConnector(module, entity, entityNode, "CT06", new BABYLON.Vector3(-entityBoundingBox.extendSize.x + (seriesDepth / 2), 0, seriesDepth), new BABYLON.Vector3(0, Math.PI / 2, 0), product.isFlipped);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT01", "CT09"])) {
                        createEntityConnector(module, entity, entityNode, "CT01_L", new BABYLON.Vector3(entityBoundingBox.extendSize.x, 0, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }

                }
                    break;
                case "CHAISELONG_LEFT": {
                    if (productLibrary.hasProductVariants(product, ["CT01"])) {
                        createEntityConnector(module, entity, entityNode, "CT01_R", new BABYLON.Vector3(-entityBoundingBox.extendSize.x, 0, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }
                }
                    break;
                case "CHAISELONG_RIGHT": {
                    if (productLibrary.hasProductVariants(product, ["CT01"])) {
                        createEntityConnector(module, entity, entityNode, "CT01_L", new BABYLON.Vector3(entityBoundingBox.extendSize.x, 0, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }
                }
                    break;
                case "CORNER_SECTION": {

                    if (productLibrary.hasProductVariants(product, ["CT10"])) {
                        createEntityConnector(module, entity, entityNode, "CT10_R", new BABYLON.Vector3(-entityBoundingBox.extendSize.x, 0, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                        createEntityConnector(module, entity, entityNode, "CT10_L", new BABYLON.Vector3(entityBoundingBox.extendSize.x - (seriesDepth / 2), 0, entityBoundingBox.extendSize.z * 2), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                    }

                }
                    break;
                case "SOFA": {

                    if (productLibrary.hasProductVariants(product, ["CT06"])) {
                        createEntityConnector(module, entity, entityNode, "CT06", new BABYLON.Vector3(-entityBoundingBox.extendSize.x + (seriesDepth / 2), 0, seriesDepth), new BABYLON.Vector3(0, Math.PI / 2, 0), product.isFlipped);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT05"])) {
                        createEntityConnector(module, entity, entityNode, "CT05", new BABYLON.Vector3(entityBoundingBox.extendSize.x - (seriesDepth / 2), 0, seriesDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                    }
                }
                    break;
                case "ARM": {

                    const backrest = productLibrary.getProductByProductNo("036-MT40-090-028-CT36 / CPI-036-MT40-090-108-00");

                    if (productLibrary.hasProductVariants(product, ["CT47"])) {
                        createEntityConnector(module, entity, entityNode, "CT47", new BABYLON.Vector3(entityBoundingBox.extendSize.x, 0, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    } 
                    if (productLibrary.hasProductVariants(product, ["CT48"])) {
                        createEntityConnector(module, entity, entityNode, "CT48", new BABYLON.Vector3(-entityBoundingBox.extendSize.x, 0, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    } 
                    if (productLibrary.hasProductVariants(product, ["CT45"])) {
                        createEntityConnector(module, entity, entityNode, "CT45", new BABYLON.Vector3(entityBoundingBox.extendSize.x, 0, backrest.depth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    } 
                    if (productLibrary.hasProductVariants(product, ["CT44"])) {
                        createEntityConnector(module, entity, entityNode, "CT44", new BABYLON.Vector3(-entityBoundingBox.extendSize.x, 0, backrest.depth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }  
                                      
                }   
                    break;
                case "SEATFRAME": {

                    if (productLibrary.hasProductVariants(product, ["CT11"])) {
                        createEntityConnector(module, entity, entityNode, "CT11", new BABYLON.Vector3(entityBoundingBox.extendSize.x + (product.width / 2), 0, 0), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    } 
                    if (productLibrary.hasProductVariants(product, ["CT37"])) {
                        createEntityConnector(module, entity, entityNode, "CT37", new BABYLON.Vector3(entityBoundingBox.extendSize.x + (product.width / 2), 0, product.depth), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    } 
                    if (productLibrary.hasProductVariants(product, ["CT04"])) {
                        createEntityConnector(module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityBoundingBox.extendSize.x, 0, product.depth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT03"])) {
                        createEntityConnector(module, entity, entityNode, "CT03", new BABYLON.Vector3(entityBoundingBox.extendSize.x, 0, product.depth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }
                }   
                    break;
                case "BACKREST": {

                    if (productLibrary.hasProductVariants(product, ["CT11"])) {
                        createEntityConnector(module, entity, entityNode, "CT11", new BABYLON.Vector3(entityBoundingBox.extendSize.x + (product.width / 2), 0, 0), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    } 
                    if (productLibrary.hasProductVariants(product, ["CT37"])) {
                        createEntityConnector(module, entity, entityNode, "CT37", new BABYLON.Vector3(entityBoundingBox.extendSize.x + (product.width / 2), 0, product.depth), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    } 
                    if (productLibrary.hasProductVariants(product, ["CT04"])) {
                        createEntityConnector(module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityBoundingBox.extendSize.x, 0, product.depth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT03"])) {
                        createEntityConnector(module, entity, entityNode, "CT03", new BABYLON.Vector3(entityBoundingBox.extendSize.x, 0, product.depth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }
                    
                }   
                    break;
                default: {
                }
                    break;
            }
        }
    }

    let createEntityConnector = function (module: Module, entity: Entity, entityNode: BABYLON.TransformNode, connectorName: string, position: BABYLON.Vector3, rotation: BABYLON.Vector3, isFlipped: boolean) {

        if (entity.connectors.filter(function (connector) { return connector.id === connectorName }).length === 0) {
            var connectorNode = BABYLON.Mesh.CreateBox(connectorName, connectorNodeSize, scene);
            connectorNode.id = entity.id + "_" + connectorName;
            connectorNode.visibility = 0;

            connectorNode.position = position;
            connectorNode.rotation = rotation;
            connectorNode.parent = entityNode;
            connectorNode.metadata = {}
            connectorNode.metadata.marker = module.id + "_" + entity.id + "_connector_" + connectorName;
            connectorNode.isPickable = true;

            var connectorMarker = new BABYLON.GUI.Image(module.id + "_" + entity.id + "_connector_" + connectorName, AppSettings.Paths.LinkIcon);
            connectorMarker.width = "48px";
            connectorMarker.height = "48px";
            connectorMarker.autoScale = false;
            connectorMarker.metadata = {}
            connectorMarker.metadata.connector = entity.id + "_" + connectorName;
            connectorMarker.alpha = 0;

            connectorMarker.onPointerClickObservable.add(function (data, state) {
                if (isPlacing) {
                    screenPointerPosition = new BABYLON.Vector2(scene.pointerX, scene.pointerY);
                    //showLoadingCanvas();
                    handleDragEnd();
                }
            });
            connectorMarker.onPointerEnterObservable.add(function (data, state) {
                if (isPlacing) {
                    connectorMarker.alpha = 0.6;
                }
            });
            connectorMarker.onPointerOutObservable.add(function (data, state) {
                if (isPlacing) {
                    connectorMarker.alpha = 1;
                }
            });

            GUI.addControl(connectorMarker);
            connectorMarker.linkWithMesh(connectorNode);

            BABYLON.Tags.EnableFor(connectorNode);
            BABYLON.Tags.AddTagsTo(connectorNode, "connector");

            entity.connectors.push({ id: connectorName, position: position, rotation: rotation } as Connector);
        }
    }

    let showHighlight = function (node: BABYLON.TransformNode) {
        if (node) {
            node.getChildMeshes(false).forEach(function (m) {
                m.overlayColor = BABYLON.Color3.FromHexString("#0461b0");
                m.overlayAlpha = 0.2;
                m.renderOverlay = true;
            });
        }
    }

    let hideHighlight = function (node: BABYLON.TransformNode) {
        if (node) {
            node.getChildMeshes(false).forEach(function (m) {
                m.renderOverlay = false;
            });
        }
    }

    let fitWeightedView = function (camera: BABYLON.ArcRotateCamera) {

        var bv = currentModuleNode.getHierarchyBoundingVectors(true, function (m) { return !BABYLON.Tags.MatchesQuery(m, "accessory") && !BABYLON.Tags.MatchesQuery(m, "entitybounds"); });
        var bb = new BABYLON.BoundingBox(bv.min, bv.max);
        var center = bb.center;

        var weightSumVector = BABYLON.Vector3.Zero();

        if (currentModule) {
            currentModule.entities.forEach(function (e) {
                var entityNode = scene.getTransformNodeByUniqueId(e.uniqueId);
                if (entityNode) {
                    var weightNode = entityNode.getChildMeshes(false, function (c) { return c.name === "weight" })[0];
                    if (weightNode) {
                        var weight = entityNode.absolutePosition.subtract(weightNode.absolutePosition);
                        weightSumVector.addInPlace(weight.normalize());
                    }
                }
            });
        }

        let directionVector = BABYLON.Vector3.Zero();

        if (Math.abs(weightSumVector.x) > Math.abs(weightSumVector.z)) {
            directionVector = new BABYLON.Vector3(1 * Math.sign(weightSumVector.x), 0, 0);
        } else {
            directionVector = new BABYLON.Vector3(0, 0, 1 * Math.sign(weightSumVector.z));
        }

        let weightedPosition = center.subtract(directionVector.scale(camera.radius));
        weightedPosition.y = bb.extendSize.y * 5;

        camera.position = weightedPosition;
        camera.rebuildAnglesAndRadius();
    }

    let fitWeightedViewV2 = function(camera: BABYLON.ArcRotateCamera) {
        var bv = currentModuleNode.getHierarchyBoundingVectors(true, function (m) { return !BABYLON.Tags.MatchesQuery(m, "accessory") && !BABYLON.Tags.MatchesQuery(m, "entitybounds"); });
        var bb = new BABYLON.BoundingBox(bv.min, bv.max);
        var center = bb.center;

         var weightSumVector = BABYLON.Vector3.Zero();

         if (currentModule) {
            currentModule.entities.forEach(function (e) {
                var entityNode = scene.getTransformNodeByUniqueId(e.uniqueId);
                if (entityNode) {
                    var weightNode = entityNode.getChildMeshes(false, function (c) { return c.name === "weight" })[0];                   
                    if (weightNode) {
                        weightSumVector = BABYLON.Vector3.Lerp(weightSumVector.normalize(), weightNode.forward.normalize(),0.5);                     
                    }
                }
            });

            let weightedPosition = center.add(weightSumVector.scale(camera.radius));
            weightedPosition.y = bb.extendSize.y * 5;

            camera.position = weightedPosition;
            camera.rebuildAnglesAndRadius();

            var currentModuleMesh = scene.getMeshByUniqueId(currentModule.uniqueId);
            fitView(currentModuleMesh, camera);       
        }         
    }

    let fitRenderTarget = function (node: BABYLON.TransformNode, camera: BABYLON.ArcRotateCamera) {

        if (node) {

            var bv = node.getHierarchyBoundingVectors();
            var bs = new BABYLON.BoundingSphere(bv.min, bv.max);

            cameraTarget = bs.center;

            let radius = bs.radiusWorld;
            if (radius === Infinity) {
                return;
            }

            let aspectRatio = engine.getAspectRatio(camera);
            let halfMinFov = camera.fov / 2;
            if (aspectRatio < 1) {
                halfMinFov = Math.atan(aspectRatio * Math.tan(camera.fov / 2))
            }

            let viewRadius = Math.abs(radius / Math.sin(halfMinFov));
            let radiusTarget = viewRadius;

            // if (viewRadius > camera.radius) {
            //     radiusTarget = viewRadius;
            //  }

            if (viewRadius < initialCameraRadius) {
                radiusTarget = initialCameraRadius;
            }

            camera.upperRadiusLimit = radiusTarget;
            camera.target = cameraTarget;
            camera.radius = radiusTarget;

            fitWeightedViewV2(camera);
        }
    }

    let fitView = function (mesh: BABYLON.TransformNode, camera?: BABYLON.ArcRotateCamera, animate: boolean = true) {

        if (mesh) {

            if (!camera) {
                camera = scene.activeCamera as BABYLON.ArcRotateCamera;
            }

            var bv = mesh.getHierarchyBoundingVectors(true, function (m) {
                return (
                    !BABYLON.Tags.MatchesQuery(m, "accessory"));
            });
            var bs = new BABYLON.BoundingSphere(bv.min, bv.max);

            cameraTarget = bs.center;

            let radius = bs.radiusWorld;
            if (radius === Infinity) {
                return;
            }

            let aspectRatio = engine.getAspectRatio(camera);
            let halfMinFov = camera.fov / 2;
            if (aspectRatio < 1) {
                halfMinFov = Math.atan(aspectRatio * Math.tan(camera.fov / 2))
            }

            let viewRadius = Math.abs(radius / Math.sin(halfMinFov));
            let radiusTarget = viewRadius;

            // if (viewRadius > camera.radius) {
            //     radiusTarget = viewRadius;
            //  }

            if (viewRadius < initialCameraRadius) {
                radiusTarget = initialCameraRadius;
            }

            camera.upperRadiusLimit = radiusTarget;

            if (animate) {
                animFitviewTarget = BABYLON.Animation.CreateAndStartAnimation("animFitviewTarget", camera, "target", 50, 60, camera.target, cameraTarget, BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT, easingFunction, function () { engine.resize(); });
                animFitviewRadius = BABYLON.Animation.CreateAndStartAnimation("animFitviewRadius", camera, "radius", 50, 60, camera.radius, radiusTarget, BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT, easingFunction, function () { engine.resize(); });
            } else {

                if (animFitviewTarget) {
                    animFitviewTarget.stop();
                }
                if (animFitviewRadius) {
                    animFitviewRadius.stop();
                }

                camera.target = cameraTarget;
                camera.radius = radiusTarget;

                engine.resize();
            }
        }
    }

    let removeEntityConnections = function (entity: Entity) {

        if (entity) {

            //Is connected?
            if (entity.connections.length > 0) {

                let connectedEntityIds = [];

                for (var c = 0; c < entity.connections.length; c++) {

                    let con = entity.connections[c];

                    var connectedEntity = currentModule.entities.find(function (x) { return x.id === con.entityId });
                    if (connectedEntity) {
                        connectedEntity.connections.forEach(function (ec) {
                            if (ec.entityId === entity.id) {
                                connectedEntityIds.push(connectedEntity.id);
                                var index = connectedEntity.connections.indexOf(ec);
                                connectedEntity.connections.splice(index, 1);
                            }
                        });
                    }
                }

                entity.connections = entity.connections.filter(function (x) { return connectedEntityIds.indexOf(x.entityId) === -1 });
            }
        }
    }

    let refreshModuleBounds = function (module: Module) {

        /*  let moduleNode = scene.getTransformNodeByUniqueId(module.uniqueId);
          if (moduleNode) {
  
              let bv = moduleNode.getHierarchyBoundingVectors(true, function (m: BABYLON.AbstractMesh) { return BABYLON.Tags.MatchesQuery(m, "entity") });
              let bb = new BABYLON.BoundingBox(bv.min, bv.max);
  
              var centerPos = new BABYLON.Vector3(bb.center.x, 0, bb.center.z);
              var positionOffset = centerPos.subtract(moduleNode.absolutePosition);
              moduleNode.position.addInPlace(positionOffset);
              moduleNode.computeWorldMatrix(true);
  
              moduleNode.getChildMeshes(true, function (entityNode) { return BABYLON.Tags.MatchesQuery(entityNode, "entity") }).forEach(function (entityNode) {
                  entityNode.setParent(null);
                  entityNode.position.subtractInPlace(positionOffset);
  
                  var entity = moduleHelper.getEntityByID(module, entityNode.id);
                  var parentNode = scene.getNodeById(entity.parentId);
  
                  entityNode.computeWorldMatrix(true);
                  entityNode.setParent(parentNode);
 
              });
          }*/
    }

    let getTargetPosition = function (screenX: number, screenY: number) {

        var target = BABYLON.Vector3.Unproject(
            new BABYLON.Vector3(screenX, screenY, 0),
            canvas.width,
            canvas.height,
            BABYLON.Matrix.Identity(),
            mainCamera.getViewMatrix(),
            mainCamera.getProjectionMatrix()
        );

        target.x = mainCamera.position.x - target.x;
        target.y = mainCamera.position.y - target.y;
        target.z = mainCamera.position.z - target.z;

        return target;

    }

    let insertEntity = function (entity: Entity, connectorInfos: ConnectorInfo[]) {

        var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);

        var parentConnection = connectorInfos[0];
        var parentConnectorEntity = moduleHelper.getEntityByID(currentModule, parentConnection.entityNode.id);
        var parentConnector = parentConnectorEntity.connectors.find(c => { return c.id === parentConnection.connectorNode.name });
        var matchingConnectors = getMatchingConnectors(parentConnector, entity, parentConnectorEntity);
        var parentConnectorNode = currentEntityNode.getChildMeshes(true, function (m) { return matchingConnectors.includes(m.name) })[0];

        var childConnection = connectorInfos[1];
        var childConnectorEntity = moduleHelper.getEntityByID(currentModule, childConnection.entityNode.id);
        var childConnector = childConnectorEntity.connectors.find(c => { return c.id === childConnection.connectorNode.name });
        var matchingConnectors = getMatchingConnectors(childConnector, entity, childConnectorEntity);
        var childConnectorNode = currentEntityNode.getChildMeshes(true, function (m) { return matchingConnectors.includes(m.name) })[0];

        connectEntities(entityNode, parentConnectorNode, parentConnection.entityNode, parentConnection.connectorNode);
        connectEntities(childConnection.entityNode, childConnection.connectorNode, entityNode, childConnectorNode);

        //Transform mesh to parent position
        setTargetRotation(childConnection.entityNode, childConnection.connectorNode, entityNode, childConnectorNode);

        //Moved connected entities       
        moveConnectedEntities(entity, []);
    }

    let weighConnection = function (module: Module, entity: Entity, connectorName: string, traversedIds: Array<number>, weight: number) {

        if (traversedIds.indexOf(entity.id) === -1) {

            traversedIds.push(entity.id);
            weight += 1;

            entity.connections.forEach(function (c) {

                if (c.id !== connectorName) {
                    var nextEntity = moduleHelper.getEntityByID(module, c.entityId);

                    if (nextEntity) {
                        nextEntity.connections.forEach(function (c) {
                            weight = weighConnection(module, nextEntity, connectorName, traversedIds, weight);
                        });
                    }
                }
            });
        }

        return weight;
    }

    /* let stopRotationAnim = function () {
         if (animRotation && animRotation.animationStarted) {
             animRotation.stop("animRotate");
         }
     }*/

    let getProductVariant = function (productNo: string, entity: Entity) {

        let product = {} as Product;
        let productVariant = {} as Product;

        let connectionType = moduleHelper.getEntityConnectionType(currentModule, entity);

        product = productLibrary.getProductByProductNo(productNo);
       
        Object.assign(productVariant, product);

        let productConnectionTypeVariant = productLibrary.getProductVariantByConnectionType(product, connectionType);

        if (!productConnectionTypeVariant) {        
            productConnectionTypeVariant = productLibrary.getProductVariantByProductNo(product);
        }

        if (productConnectionTypeVariant) {
            productVariant.productNo = productConnectionTypeVariant.productNo;
            productVariant.axProductNo = productConnectionTypeVariant.axProductNo;
            productVariant.name = productConnectionTypeVariant.name;
            productVariant.model = productConnectionTypeVariant.model ?? product.model;
            productVariant.isFlipped = productConnectionTypeVariant.isFlipped;
        }

        switch (product.type) {
            case "SOFA": {

                if (entity.connections.length === 1 && product.series === 4220) {

                    switch (productConnectionTypeVariant.connectionType) {
                        case "CT06":
                            {
                                productConnectionTypeVariant = productLibrary.getProductVariantByConnectionType(product, "CT05");
                                productVariant.model = productConnectionTypeVariant.model;
                                productVariant.isFlipped = true;
                            }
                            break;
                    }
                }
            }
                break;
            case "FOOTSTOOL": {

                if (productVariant.width !== productVariant.depth) {

                    var seriesDepth = getSeriesDepth();
                    var width = productVariant.width;
                    var depth = productVariant.depth;

                    if (connectionType !== "CT11" && connectionType !== "CT00") {
                        var tmp = depth;
                        depth = width;
                        width = tmp;
                    }

                    if (width >= seriesDepth && depth >= seriesDepth) {
                        var tmp = width;
                        width = depth;
                        depth = tmp;
                    }

                    productVariant.depth = depth;
                    productVariant.width = width;
                }
            }
        }

        return productVariant;

    }


    /*let getProductVariant = function (product: Product, entity: Entity): Product {

        var productVariant = {} as Product;

        Object.assign(productVariant, product);

        var productConnectionTypeVariant = productLibrary.getFirstProductVariant(product);
        if (productConnectionTypeVariant) {
           productVariant.isFlipped = productConnectionTypeVariant.isFlipped;
        }

       // if (entity) {

            var connectionType = moduleHelper.getEntityConnectionType(currentModule, entity);
            productConnectionTypeVariant = productLibrary.getProductVariantByConnectionType(product, connectionType);

            if (productConnectionTypeVariant) {
                productVariant.productNo = productConnectionTypeVariant.productNo;
                productVariant.axProductNo = productConnectionTypeVariant.axProductNo;
                productVariant.name = productConnectionTypeVariant.name;
                productVariant.model = productConnectionTypeVariant.model ?? product.model;
                productVariant.isFlipped = productConnectionTypeVariant.isFlipped;
            }

            //HACK! Rules to handle which product is shown based on connections!
            switch (product.type) {
                case "SOFA": {

                    if (entity.connections.length === 1 && product.series === 4220) {

                        // var connection = entity.connections[0];
                        // productVariant.productNo += "_LEFT";
                        //   productVariant.model = productVariant.model.substring(0, productVariant.model.lastIndexOf("_")) + "_LEFT" + productVariant.model.substring(productVariant.model.lastIndexOf("_"));

                        switch (productConnectionTypeVariant.connectionType) {
                            case "CT06":
                                {
                                    var productConnectionTypeVariant = productLibrary.getProductVariantByConnectionType(product, "CT05");
                                    productVariant.model = productConnectionTypeVariant.model;
                                    productVariant.isFlipped = true;
                                }
                                break;
                        }
                    }
                }
                    break;
                case "FOOTSTOOL": {

                    // var productVariantConnectionType = productLibrary.getProductVariantByConnectionType(product,connectionType);                  

                    // var connectionType = moduleHelper.getEntityConnectionType(currentModule, entity);
                    if (productVariant.width !== productVariant.depth) {

                        var seriesDepth = getSeriesDepth();
                        var width = productVariant.width;
                        var depth = productVariant.depth;

                        if (connectionType !== "CT11" && connectionType !== "CT00") {
                            var tmp = depth;
                            depth = width;
                            width = tmp;
                        }

                        if (width >= seriesDepth && depth >= seriesDepth) {
                            var tmp = width;
                            width = depth;
                            depth = tmp;
                        }

                        productVariant.depth = depth;
                        productVariant.width = width;
                        //  productVariant.productNo += "_" + width + "X" + depth;
                        // productVariant.model = productVariant.model.substring(0, productVariant.model.lastIndexOf("_")) + "_" + width + "X" + depth + "cm";

                    }
                }
           // }
        }

        return productVariant;
    }*/

    /*  let removeEntityOfType = function (module: Module, type: string) {
          module.entities.filter(x => x.category === type).forEach((entity, index) => {
              var removableEntityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
              if (removableEntityNode) {
                  removableEntityNode.dispose();
                  removableEntityNode = null;
              }
  
              var index = module.entities.indexOf(entity);
              module.entities.splice(index, 1);
          });
      }*/

    let onProgress = function (e: any) {

        let entity = moduleHelper.getEntityByID(currentModule, e.id);

        let progressbarBg = GUI.rootContainer.getChildByName(currentModule.id + "_" + entity.id + "_progressbg");
        if (!progressbarBg) {
            createProgressBar(currentModule, entity);
            progressbarBg = GUI.rootContainer.getChildByName(currentModule.id + "_" + entity.id + "_progressbg");
        }

        let progressbarPct = GUI.rootContainer.getChildByName(currentModule.id + "_" + entity.id + "_progresspct");
        if (progressbarPct) {
            progressbarPct.width = (e.received / e.total) * 100 + "px";
        }

        if (Math.round((e.received / e.total) * 100) === 100) {
            if (progressbarBg)
                progressbarBg.dispose();

            if (progressbarPct)
                progressbarPct.dispose();
        }
    }

    let constructModule = function (module: Module) {

        return new Promise(resolve => {

            //Dispose all UI and models from scene
            cleanupAssets();

            if (module) {

                displaySummaryButton(false);
                showLoadingCanvas();

                instantiateModule(currentConfiguration, module, function (instantiatedModule, instantiatedModuleNode) {

                    if (module.entities.length === 0) {
                        hideLoadingCanvas();
                    }

                    currentModule = instantiatedModule;
                    currentModuleNode = instantiatedModuleNode;

                    module.entities.filter(function (e) { return e.parentId === module.id }).forEach(function (entity: Entity) {

                        let product = productLibrary.getProductByProductNo(entity.productNo);

                        instantiateEntity(module, product, entity, function (instantiatedEntity, instantiatedEntityNode) {

                            var productVariant = getProductVariant(instantiatedEntity.productNo, instantiatedEntity);
                            instantiatedEntity.variantProductNo = productVariant.productNo;
                            instantiatedEntityNode.metadata.productNo = productVariant.productNo;

                            var entityBounds = instantiatedEntityNode.getChildMeshes(true, function (m) { return m.id === "entitybounds" })[0];
                            entityBounds.setEnabled(true);

                            //Handle variant if available (default values if not)
                            //     let entityConnectionType = moduleHelper.getEntityConnectionType(module, instantiatedEntity);

                            //Create legs
                            constructLegs(module, instantiatedEntity);

                            //Load entity mesh
                            meshLibrary.loadMeshAsync(productVariant.productNo, instantiatedEntity, productVariant.type, "furniture/", productVariant.model + ".glb", productVariant.isFlipped, scene, false, sg, sg2, onProgress, function (clonedMeshEntityId, clonedMesh) {

                                // var clonedEntity = moduleHelper.getEntityByID(module, clonedMeshEntityId)

                                //HACK! Rotate mesh if connection type CT11
                                //rotateCushions(entityConnectionType, clonedEntity, clonedMesh, productVariant);

                                clonedMesh.scaling.x = productVariant.isFlipped ? -1 : 1;
                                clonedMesh.position.y = currentConfiguration.data.offsetY;

                                //Set material
                                let material = materialLibrary.getMaterialByProductNumber(currentConfiguration.data["material"]);
                                if (material) {
                                    materialLibrary.assignMaterial(Y, productVariant, [clonedMesh], material, scene, function () {
                                        clonedMesh.setEnabled(true);
                                    });
                                }




                            });
                        });
                    });

                    hideAllHighlights();
                    hideEntityActions();

                    moveAllEntities(currentModule);
                    refreshModuleBounds(currentModule);
                    validateConstruction(currentModule);

                    displaySummaryButton(true);
                    updateSummaryMenuTotalPrice();

                    window.dispatchEvent(new Event("saveconfigurations"));

                    pauseRender();
                    resumeRender().then(() => {

                        window.dispatchEvent(new Event("thumbnail_render"));

                        mainCamera.attachControl(canvas, true, false);

                        fitView(currentModuleNode, mainCamera, false);

                        hideLoadingCanvas();

                        resolve(true);
                    });
                });
            }
        });
    }

    let rotateCushions = function (connectionType: string, entity: Entity, entityNode: BABYLON.TransformNode, product) {
        var clonedMeshChildMeshes = entityNode.getChildMeshes(false, function (e) { return e.id.includes(product.productNo + "_clone") });
        if (connectionType === "CT11" && product.width === product.depth && entity.connections.length === 1) {
            clonedMeshChildMeshes.forEach(function (cm) {
                cm.rotation = new BABYLON.Vector3(0, 0, Math.PI / 2);
            })
        }

    }

    let constructLegs = function (module: Module, entity: Entity) {

        //Filter out existing legs
        module.entities = module.entities.filter(x => x.parentId !== entity.id);

        var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
        var entityProduct = productLibrary.getProductByProductNo(entity.productNo);
        var series = seriesLibrary.getSeriesById(entityProduct.series);

        var attachmentNodes = entityNode.getChildTransformNodes(true, function (cm) { return BABYLON.Tags.MatchesQuery(cm, "leg") });
        attachmentNodes.forEach(function (attNode) {

            var offsetSide: number, offsetFront: number, rotation: number = 0;

            var legTags = BABYLON.Tags.GetTags(attNode) as string;
            var legType: string = legTags.split(" ")[1];
            var legProduct = seriesLibrary.getSeriesLeg(series, "standard", legType);

            var rotation = legProduct.legRotation;
            var offsetFront = ConversionHelper.scale(legProduct.legOffsetFromFront, scaleFactor) as number || 0;
            var offsetSide = ConversionHelper.scale(legProduct.legOffsetFromSide, scaleFactor) as number || 0;

            if (!currentConfiguration.data.offsetY) {
                currentConfiguration.data.offsetY = ConversionHelper.scale(legProduct.height, 0.001) as number || 0;
            }

            switch (attNode.id) {
                case entityNode.id + "_attachment_right_front": {
                    offsetSide = -offsetSide;
                    offsetFront = -offsetFront;
                }
                    break;
                case entityNode.id + "_attachment_left_front": {
                    offsetSide = -offsetSide;
                    offsetFront = -offsetFront;
                }
                    break;
                case entityNode.id + "_attachment_right_back": {
                    offsetSide = -offsetSide;
                    offsetFront = -offsetFront;
                }
                    break;
                case entityNode.id + "_attachment_left_back": {
                    offsetSide = -offsetSide;
                    offsetFront = -offsetFront;
                }
                    break;
            }

            var legProductVariant = {} as Product;
            legProductVariant.productNo = legProduct.productNumber;
            legProductVariant.width = legProductVariant.height = legProductVariant.depth = 0.01;
            legProductVariant.model = legProduct.model;
            legProductVariant.type = "LEG";

            instantiateEntity(module, legProductVariant, null, function (instantiatedEntity, instantiatedEntityNode) {

                var entityNode = scene.getTransformNodeByUniqueID(instantiatedEntity.uniqueId);
                var entityBounds = entityNode.getChildMeshes(true, function (m) { return m.id === "entitybounds" })[0];
                entityBounds.setEnabled(false);

                //Offset legs based on certain rules defined by series
                //handleLegVariantOffsets(entity, entityProduct, legType, offsetSide, offsetFront);

                instantiatedEntity.parentId = entity.id;
                instantiatedEntityNode.parent = attNode;
                instantiatedEntityNode.metadata = {};
                instantiatedEntityNode.metadata.productNo = legProductVariant.productNo;
                instantiatedEntityNode.rotation.addInPlace(new BABYLON.Vector3(0, BABYLON.Angle.FromDegrees(rotation).radians(), 0));
                instantiatedEntityNode.computeWorldMatrix(true);
                instantiatedEntityNode.position.addInPlace(new BABYLON.Vector3(offsetSide, 0, offsetFront));

                meshLibrary.loadMeshAsync(legProductVariant.productNo, instantiatedEntity, "leg", "legs/", legProductVariant.model + ".glb", false, scene, true, sg, sg2, null, function (clonedMeshEntityId, clonedMesh) {
                });

            });
        });
    }

    let handleLegVariantOffsets = function (entity: Entity, entityProduct: Product, legType: string, offsetSide: number, offsetFront: number) {

        switch (entity.category) {
            case "FOOTSTOOL": {
                if (entityProduct.depth === entityProduct.width) {
                    if (entity.connections.map(x => x.id).includes("CT10")) {
                        offsetSide = 0;
                    }
                }
            }
                break;
        }

    }

    let validateConstruction = function (module: Module) {

        errorHandler.resetErrors();

        var filteredEntities = module.entities.filter(function (entity: Entity) { return productLibrary.getProductCategory(entity.category) === "UPHOLSTRY" });
        filteredEntities.forEach(function (entity: Entity) {

            let entityMesh = scene.getTransformNodeByUniqueId(entity.uniqueId);
            entityMesh.computeWorldMatrix(true);

            var entityBounds = entityMesh.getChildMeshes(true, function (cm) { return cm.id === "entitybounds" })[0] as BABYLON.AbstractMesh;
            entityBounds.computeWorldMatrix(true);

            var product = productLibrary.getProductByProductNo(entity.productNo);

            if (entity.connections.length === 0 && !productLibrary.hasProductVariants(product, ["CT00"])) {
                errorHandler.addError("Producttype " + product.type + " is not allowed as freestanding module");
            }

            filteredEntities.forEach(function (entityCheck: Entity) {

                if (entity.id !== entityCheck.id) {
                    if (entity.connections.filter(function (e) { return e.entityId === entityCheck.id }).length === 0) {

                        let entityCheckMesh = scene.getTransformNodeByUniqueId(entityCheck.uniqueId);
                        entityCheckMesh.computeWorldMatrix(true);
                        var entityCheckBounds = entityCheckMesh.getChildMeshes(true, function (cm) { return cm.id === "entitybounds" })[0] as BABYLON.AbstractMesh;
                        entityCheckBounds.computeWorldMatrix(true);

                        if (entityBounds.intersectsMesh(entityCheckBounds, false, false)) {
                            errorHandler.addError("Current module construction is not valid, because modules intersect each other");
                        }
                    }
                }

                var entityProduct = productLibrary.getProductByProductNo(entity.productNo);
                if (entityProduct.type === "CORNER_SECTION") {
                    if (entity.connections.length < 2) {
                        errorHandler.addError("Corner sections cannot stand individually and have to be connected on all sides");
                    }
                }
            });
        });

    }

    //Append entity to current connector
    let appendEntity = function (entity: Entity, connectorInfo: ConnectorInfo) {

        if (currentEntityNode) {
            var parentNode = connectorInfo.entityNode;
            var parentConnector = connectorInfo.connectorNode;
            var childNode = currentEntityNode;

            //Determine matching connector
            var connectorEntity = moduleHelper.getEntityByID(currentModule, connectorInfo.entityNode.id);
            var connector = connectorEntity.connectors.find(c => { return c.id === connectorInfo.connectorNode.name });
            var matchingConnectors = getMatchingConnectors(connector, entity, connectorEntity);
            var childConnector = currentEntityNode.getChildMeshes(true, function (m) { return matchingConnectors.includes(m.name) })[0];

            //Dragged over single unconnected connector
            moveEntity(parentNode, parentConnector, childNode, childConnector);

            //Connect neighbouring entities
            connectNeighbourEntities(entity);
        }
    }

    let connectNeighbourEntities = function (entity: Entity) {

        //Get entity node
        var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
        if (entityNode) {

            entityNode.computeWorldMatrix(true);

            let filteredEntities = currentModule.entities.filter(e => { return productLibrary.getProductCategory(e.category) === "UPHOLSTRY" && e.id !== entity.id });

            //Iterate entity connectors
            entity.connectors.forEach(function (connector: Connector) {

                //Determine if connector already has connection             
                var entityConnector = entityNode.getChildMeshes(false, function (childNode) { return childNode.id.indexOf(connector.id) >= 0 })[0];
                entityConnector.computeWorldMatrix(true);

                filteredEntities.forEach(function (availableEntity) {

                    var availableEntityNode = scene.getTransformNodeByUniqueId(availableEntity.uniqueId);
                    if (availableEntityNode) {
                        availableEntityNode.computeWorldMatrix(true);

                        var matchingConnectors = getMatchingConnectors(connector, entity, availableEntity);
                        matchingConnectors.forEach(connectorId => {
                            var matchingConnector = availableEntityNode.getChildMeshes(true, function (childNode) { return childNode.name === connectorId })[0];

                            if (matchingConnector) {
                                matchingConnector.computeWorldMatrix(true);

                                let distance = ConversionHelper.scale(10, scaleFactor) as number;

                                if (BABYLON.Vector3.Distance(entityConnector.getAbsolutePosition(), matchingConnector.getAbsolutePosition()) <= distance) {

                                    var entityConnection = entity.connections.find(function (connection) { return connection.id === connector.id });
                                    if (entityConnection) {
                                        var connectionIndex = entity.connections.indexOf(entityConnection);
                                        entity.connections.splice(connectionIndex, 1);
                                    }

                                    connectEntities(entityNode, entityConnector, availableEntityNode, matchingConnector);
                                }
                            }
                        });
                    }

                });
            });
        }
    }

    let openConfig = async function (identifier: string) {

        if (identifier) {

            let project = await projectLibrary.getProject(identifier);
            currentProject = project;
            currentConfiguration = project.configurations[0];

            if (!currentConfiguration)
                return false;

            if (currentConfiguration.data.modules.length > 0)
                currentModule = currentConfiguration.data.modules[0];

            seriesLibrary.fetchSeriesByName(currentConfiguration.series).then((series) => {

                var defaultLeg = seriesLibrary.getSeriesLeg(series, "standard");

                currentConfiguration.data.options["leg"] = currentConfiguration.data.options["leg"] || defaultLeg.productNumber;

                materialLibrary.defaultMaterial = series.defaultMaterial;
                materialLibrary.materials = series.materials;

                renderProject().then(() => {
                    constructModule(currentModule).then(() => {
                        resetMainCamera();
                        fitView(currentModuleNode, mainCamera, false);
                    });
                });
            });
        }
    }


    /**
     * Drag Functions
     * */

    //Handle Drag
    let handleDrag = function () {

        if (currentEntityNode) {

            var entity = getCurrentEntity();
            if (entity) {
                toggleMeshVisibility(currentEntityNode, MeshVisibility.HIGHLIGHTED);

                //Remove entity connection if any
                //removeEntityConnections(entity);
                //  stopRotationAnim();
                hideEntityActions();

                let connectorInfos = getPositionConnectorInfo(screenPointerPosition, currentEntityNode);
                if (connectorInfos.length > 0) {

                    connectorInfos.forEach(function (connectorInfo: ConnectorInfo) {
                        var connectorEntity = moduleHelper.getEntityByID(currentModule, connectorInfo.entityNode.id);
                        var connectorEntityNode = scene.getTransformNodeById(connectorEntity.id);

                        if (connectorInfos.length === 2) {
                            showHighlight(connectorEntityNode);
                        }

                        if (connectorInfo.isEnabled) {
                            showHighlight(connectorEntityNode);
                        }
                    });

                    //connectorInfos.forEach(function (connectorInfo: ConnectorInfo) {
                    var connectorInfo = connectorInfos[0];
                    var connectorEntity = moduleHelper.getEntityByID(currentModule, connectorInfo.entityNode.id);
                    var connector = connectorEntity.connectors.find(c => { return c.id === connectorInfo.connectorNode.name });
                    var matchingConnectors = getMatchingConnectors(connector, entity, connectorEntity);
                    var childConnector = currentEntityNode.getChildMeshes(true, function (m) { return matchingConnectors.includes(m.name) })[0];

                    if (childConnector) {

                        //  var connectorEntityNode = scene.getTransformNodeById(connectorEntity.id);

                        //Highlight connector entity
                        if (connectorInfo.isEnabled) {
                            showHighlight(connectorInfo.entityNode);
                            // currentEntityNode.rotation = BABYLON.Vector3.Zero();
                            //  currentEntityNode.computeWorldMatrix(true);
                            setTargetRotation(connectorInfo.entityNode, connectorInfo.connectorNode, currentEntityNode, childConnector);
                        }
                        //entity.rotation = targetRotation;
                        /*if (currentEntityNode) {
                            currentEntityNode.rotation = targetRotation;
                            // currentEntityNode.computeWorldMatrix(true);
                        }*/

                        // currentEntityNode.computeWorldMatrix(true);

                        if (!currentConnector || currentConnector.uniqueId !== connectorInfo.connectorNode.uniqueId) {

                            currentConnector = connectorInfo.connectorNode as BABYLON.AbstractMesh;
                            // stopRotationAnim();
                            setTargetRotation(connectorInfo.entityNode, connectorInfo.connectorNode, currentEntityNode, childConnector);
                            currentEntityNode.rotation = targetRotation;
                            //  animateRotation(currentEntityNode, targetRotation);
                        }
                    }

                    //});

                } else {

                    //stopRotationAnim();
                    hideAllHighlights();
                    //showHighlight(currentEntityNode);
                    /*  if (currentEntityNode) {
                          currentEntityNode.rotation.y = entity.rotation.y;
                      }*/
                }
            }
        }
    }

    //Handle Drag End
    let handleDragEnd = function () {

        var entity = getCurrentEntity();
        if (entity) {

            toggleMeshVisibility(currentModuleNode, MeshVisibility.VISIBLE);
            hideEntityActions();

            //Get effected connectors
            let connectorInfos = getPositionConnectorInfo(screenPointerPosition, currentEntityNode);
            if (connectorInfos.length > 0) {
                //Dragged over single unconnected connector
                if (connectorInfos.length === 1) {
                    let connectorInfo = connectorInfos[0] as ConnectorInfo;

                    if (connectorInfo.isEnabled) {
                        removeEntityConnections(entity);

                        //Append entity
                        appendEntity(entity, connectorInfo);
                        currentAction = ACTIONS.DRAGOVER
                    }

                    //Dragged over already connected connectors (insert etc.)
                } else if (connectorInfos.length > 1) {

                    removeEntityConnections(entity);

                    //Insert entity
                    insertEntity(entity, connectorInfos);
                    currentAction = ACTIONS.DRAGOVER
                }
            } else {

                //Entity not connected to anything yet (no need to reconstruct)
                //currentEntityNode.rotation.y = entity.rotation.y;

                if (entity.connections.length > 0) {
                    removeEntityConnections(entity);
                    currentAction = ACTIONS.DRAGOVER
                } else {

                    hideAllHighlights();
                    hideEntityActions();
                    refreshModuleBounds(currentModule);
                    validateConstruction(currentModule);

                    window.dispatchEvent(new Event("saveconfigurations"));

                    pauseRender();

                    resumeRender().then(() => {

                        window.dispatchEvent(new Event("thumbnail_render"));

                        updateSummaryMenuTotalPrice();

                        mainCamera.attachControl(canvas, true, false);
                        fitView(currentModuleNode, mainCamera, false);

                        hideLoadingCanvas();

                    });
                }
            }

            currentEntityNode = null;

            if (currentAction == ACTIONS.DRAGOUT || currentAction == ACTIONS.DRAGOVER) {
                currentAction = ACTIONS.NONE;
                constructModule(currentModule)
            }
        }
    }

    //Drag Start (Canvas)
    let dragStartCanvas = function () {

        isDragging = true;
        var entity = getCurrentEntity();

        if (entity.connections.length > 0) {
            currentAction = ACTIONS.DRAGOUT
        }

        removeEntityConnections(entity);
        showAvailableConnectors(currentModule, entity);

    }

    //Drag (Canvas)   
    let dragCanvas = function () {

        if (isDragging) {
            handleDrag();
        }
    }

    //Drag End (Canvas)
    let dragEndCanvas = function () {

        if (isDragging) {

            isDragging = false;
            handleDragEnd();
            hideAvailableConnectors();
        }
    }

    //YUI Drag Drop

    var dropCanvas = Y.one('#renderCanvasDrop').plug(Y.Plugin.Drop);

    var del = new Y.DD.Delegate({
        container: '.config-menu .config-menu__submenues__submenu[data-menuview="modules"] .product-selector .selector__items',
        nodes: 'li.product.draggable img',
        dragMode: 'intersect'
    });

    del.dd.on("drag:start", function (e) {
        e.preventDefault();
        dragUIStart(e);
    });

    del.dd.on("drag:drag", function (e) {
        e.preventDefault();
        if (isOverCanvas && isDragging) {
            dragUI(e);
        }

    });

    dropCanvas.drop.on('drop:over', function (e) {
        isOverCanvas = true;
    });

    dropCanvas.drop.on('drop:hit', function (e) {
        if (isDragging) {
            isOverCanvas = false;
            dragUIEnd();
        }
    });

    /* Y.one(".scrollable__content").on("scroll", function (e) {
         e.preventDefault();
         del.dd.stopDrag();
         isDragging = false;
     });*/

    /*var dropMenu = Y.one('.config-menu').plug(Y.Plugin.Drop);
    dropMenu.drop.on('drop:hit', function (e) {
        if (isDragging) {
            isOverCanvas = false;
            dragUIEnd();
        }
    });*/

    del.dd.plug(Y.Plugin.DDProxy, {
        moveOnEnd: false,
        cloneNode: true
    });

    //Drag Start (UI)
    var dragUIStart = function (evt) {

        hideHighlight(currentEntityNode);
        currentEntityNode = null;

        let elem = evt.target.get("node");
        let productElem = elem.ancestor("li");
        elem.addClass("dragged");

        meshLoading = false;
        isDragging = true;

        mainCamera.detachControl();

        let productNumber = productElem.getData("productnumber") as string;
        currentProduct = productLibrary.getProductByProductNo(productNumber);
    };

    //Drag (UI)
    var dragUI = function (evt) {

        hideEntityActions();

        screenPointerPosition = new BABYLON.Vector2(evt.target.mouseXY[0], evt.target.mouseXY[1] - 60);
        scenePointerPosition = getTargetPosition(screenPointerPosition.x, screenPointerPosition.y);
        dragPosition = getZeroPlaneVector(mainCamera.position, scenePointerPosition);

        var distance = BABYLON.Vector3.Distance(mainCamera.position, scenePointerPosition);

        if (!dragPosition && !distance) {
            isDragging = false;
        }

        if (isDragging) {

            //Create mesh
            if (BABYLON.Vector3.Distance(cameraTarget, dragPosition) <= distance) {

                if (!meshLoading) {
                    meshLoading = true;

                    //Instantiate module
                    instantiateModule(currentConfiguration, currentModule, function (module, moduleNode) {

                        currentModule = module;
                        currentModuleNode = moduleNode;

                        var product = productLibrary.getProductByProductNo(currentProduct.productNo);

                        //Instatiate entity
                        instantiateEntity(module, product, null, function (instantiatedEntity, instantiatedEntityNode) {

                            var productVariant = getProductVariant(instantiatedEntity.productNo, instantiatedEntity);
                            instantiatedEntity.variantProductNo = productVariant.productNo;
                            instantiatedEntityNode.metadata.productNo = productVariant.productNo;

                            var entityBounds = instantiatedEntityNode.getChildMeshes(true, function (m) { return m.id === "entitybounds" })[0];
                            entityBounds.setEnabled(true);

                            //Set current selected entity
                            currentEntityNode = instantiatedEntityNode;

                            //Show available connectors
                            showAvailableConnectors(module, instantiatedEntity);

                            //Create legs
                            constructLegs(module, instantiatedEntity);

                            //Load entity mesh                        
                            meshLibrary.loadMeshAsync(productVariant.productNo, instantiatedEntity, productVariant.type, "furniture/", productVariant.model + ".glb", productVariant.isFlipped, scene, false, sg, sg2, onProgress, function (clonedMeshEntityId, clonedMesh) {

                                //Set material
                                let material = materialLibrary.getMaterialByProductNumber(currentConfiguration.data["material"]);
                                if (material) {
                                    materialLibrary.assignMaterial(Y, productVariant, [clonedMesh], material, scene, function () {
                                        clonedMesh.setEnabled(true);
                                    });
                                }

                                clonedMesh.scaling.x = productVariant.isFlipped ? -1 : 1;
                                clonedMesh.position.y = currentConfiguration.data.offsetY;
                            });

                        });
                    });
                }
            }

            /*  switch (viewMode) {
                  case "plan": {
                      if (currentModuleNode) {
                          currentModuleNode.setAbsolutePosition(new BABYLON.Vector3(dragPosition.x, currentModuleNode.position.y, dragPosition.z));
                      }
                  }
                      break;
                  case "module": {*/

            if (currentEntityNode) {

                //Move according to real center of entity
                var centerNode = currentEntityNode.getChildTransformNodes(false, function (m) { return m.id === "center" })[0];
                dragPosition.subtractInPlace(centerNode.position);

                currentEntityNode.setAbsolutePosition(new BABYLON.Vector3(dragPosition.x, currentEntityNode.position.y, dragPosition.z));

                handleDrag();
            }

            /*    }
                    break;
            }*/
        }

    };

    //Drag End (UI)
    var dragUIEnd = function () {

        if (!currentEntityNode && !currentModuleNode) {
            isDragging = false;
            return false;
        }

        if (isDragging) {

            isDragging = false;

            handleDragEnd();
            hideAvailableConnectors();

            updateSummaryMenuTotalPrice();

            Y.all(".menu .menu--item ul li").each(function (el) {
                el.removeClass("dragged");
            });
        }
    };

    var getZeroPlaneVector = function (pos, rot) {
        return getHorizontalPlaneVector(0, pos, rot);
    };

    var getHorizontalPlaneVector = function (y, pos, rot) {
        if (!rot.y) {
            return null; // no solution, as it will never hit the zero plane
        }
        return new BABYLON.Vector3(
            pos.x - (pos.y - y) * rot.x / rot.y,
            0,
            pos.z - (pos.y - y) * rot.z / rot.y
        );
    };

    var debounce = function (fn, delay) {
        var timer = null;
        return function () {
            var context = this, args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                fn.apply(context, args);
            }, delay);
        };
    }

    let updateProjectsList = async function () {

        showLoader();

        let pagenationPageCount = Y.one(".pagenation-pagecount");
        pagenationPageCount.setHTML("");

        let firstPage = Y.one(".pagenation button.first");
        let nextPage = Y.one(".pagenation button.next");
        let prevPage = Y.one(".pagenation button.prev");
        let lastPage = Y.one(".pagenation button.last");

        firstPage.setAttribute("disabled");
        nextPage.setAttribute("disabled");
        prevPage.setAttribute("disabled");
        lastPage.setAttribute("disabled");

        let projectTable = Y.one(".configurations-page table.project-list");
        let projectTableBody = projectTable.one("tbody");
        projectTableBody.empty();

        if (projectFilter.currentPage > Math.ceil(projectLibrary.count / projectFilter.itemsShown))
            projectFilter.currentPage = Math.ceil(projectLibrary.count / projectFilter.itemsShown);

        if (projectFilter.currentPage < 1)
            projectFilter.currentPage = 1;

        await projectLibrary.getAllProjects(projectFilter);

        //Page count
        if (Math.ceil(projectLibrary.count / projectFilter.itemsShown) > 0) {
            pagenationPageCount.setHTML(i18next.t("projectlist.currentpages", { count: projectFilter.currentPage, pages: Math.ceil(projectLibrary.count / projectFilter.itemsShown) }));
            // pagenationPageCount.setHTML(`${projectFilter.currentPage} of ${Math.ceil(projectLibrary.count / projectFilter.itemsShown)} pages`);           
        }

        if (projectFilter.currentPage > 1) {
            prevPage.removeAttribute("disabled");
            firstPage.removeAttribute("disabled");
        }
        if (projectFilter.currentPage < Math.ceil(projectLibrary.count / projectFilter.itemsShown)) {
            nextPage.removeAttribute("disabled");
            lastPage.removeAttribute("disabled");
        }

        projectLibrary.projects.forEach(function (project: Project) {

            let projectRow = Y.Node.create("<tr>");

            let projectName = Y.Node.create(`<td>${project.name}</td>`);
            projectRow.appendChild(projectName);
            let projectEmail = Y.Node.create(`<td>${project.seller}</td>`);
            projectRow.appendChild(projectEmail);
            let projectPhone = Y.Node.create(`<td>${project.phone}</td>`);
            projectRow.appendChild(projectPhone);
            let projectDate = Y.Node.create(`<td>${FormatHelper.formatDate(project.added)}</td>`);
            projectRow.appendChild(projectDate);
            let projectStatus = Y.Node.create(`<td><span class="status mr-2"><i class="status-${getStatus(project.status).toLowerCase()}"></i></span><span>${i18next.t('common.statuses.' + getStatus(project.status).toLowerCase())}</span></td>`);
            projectRow.appendChild(projectStatus);

            //let projectActions = Y.Node.create(`<td><a class="contextmenu-handle" data-id=${project.identifier}><span class="icon is-small"><i class="fas fa-ellipsis-h"></i></span></a></td>`);
            //projectRow.appendChild(projectActions);

            let projectActions = Y.Node.create(`<td><div class="project-actions dropdown is-right">
                <div class="dropdown-trigger">
                    <a><span class="icon is-small"><i class="fas fa-ellipsis-h"></i></span></a>
                </div>
                <div class="dropdown-menu">
                    <div class="dropdown-content">
                        <a href="#" class="open-project dropdown-item" data-id=${project.identifier}>
                            <span>${i18next.t('projectlist.open')}</span>
                            <span class="icon is-small is-right"><i class="fas fa-long-arrow-right"></i></span>
                        </a>
                        <a href="#" class="edit-project dropdown-item" data-id=${project.identifier}>
                            <span>${i18next.t('projectlist.edit')}</span>
                            <span class="icon is-small is-right"><i class="fas fa-cog"></i></span>
                        </a>
                    </div>
                </div>
                </div></td>`);
            projectRow.appendChild(projectActions);

            projectTableBody.appendChild(projectRow);

        });

        projectTable.appendChild(projectTableBody);

        hideLoader();
    }

    let getStatus = (status: number) => {

        switch (status) {
            case 0:
                return "Inactive";
            case 1:
                return "Active";
            case 2:
                return "Ordered";
        }

    }

    let updateSeriesList = async function () {

        let list = Y.one(".series-page ul.series-list");
        list.empty();

        let heightTypes = ["large", "small", "medium", "medium", "large", "small"];
        let heightType = 0;

        var seriesData = await seriesLibrary.fetchSeries();
        seriesData.forEach(function (series) {

            var seriesNode = Y.Node.create("<li>");
            seriesNode.addClass("tile-list-item " + heightTypes[heightType]);
            seriesNode.setAttribute("data-series", series.id);

            var imgElem = Y.Node.create("<div>");
            imgElem.addClass("tile-img");

            var img = new Image();
            img.src = series.thumbnail;
            img.onload = function (e) {
                imgElem.setStyle("backgroundImage", "url('" + series.thumbnail + "')");
                imgElem.addClass("is-shown");
            }
            img.onerror = function (e) {
                console.log("Image not found")
            }
            seriesNode.appendChild(imgElem);

            var name = Y.Node.create("<div>");
            name.addClass("tile-name");
            seriesNode.appendChild(name);

            var span = Y.Node.create("<span>");
            span.setHTML(series.name);
            name.appendChild(span);

            list.appendChild(seriesNode);

            heightType++;
            if (heightType >= heightTypes.length) {
                heightType = 0;
            }

        });

        seriesList.fitWidth();

    }

    let updatePresetList = function () {

        let list = Y.one(".series-page ul.preset-list");
        list.empty();

        let heightTypes = ["large", "small", "medium", "medium", "large", "small"];
        let heightType = 0;

        //New item
        var presetNode = Y.Node.create("<li>");
        presetNode.addClass("tile-list-item " + heightTypes[heightType] + " is-new");
        presetNode.setAttribute("data-preset", "");

        var name = Y.Node.create("<div>");
        name.addClass("tile-name");
        presetNode.appendChild(name);

        var span = Y.Node.create("<span>");
        span.setHTML("Configure");
        name.appendChild(span);

        list.appendChild(presetNode);

        let series = seriesLibrary.getSeriesByName(currentConfiguration.series);
        series.presets.forEach(function (preset) {

            var presetNode = Y.Node.create("<li>");
            presetNode.addClass("tile-list-item " + heightTypes[heightType]);
            presetNode.setAttribute("data-preset", preset.id);

            var img = Y.Node.create("<div>");
            img.addClass("tile-img");
            img.setStyle("backgroundImage", "url('" + preset.thumbnail + "')");
            presetNode.appendChild(img);

            var name = Y.Node.create("<div>");
            name.addClass("tile-name");
            presetNode.appendChild(name);

            var span = Y.Node.create("<span>");
            span.setHTML(preset.name);
            name.appendChild(span);

            list.appendChild(presetNode);

            heightType++;
            if (heightType >= heightTypes.length) {
                heightType = 0;
            }

        });

        presetList.fitWidth();
    }

    let updateConfigurationSelector = function () {

        let listNode = Y.one(".configuration-selector ul");
        listNode.empty();

        currentProject.configurations.sort((a, b) => { return a.data.id > b.data.id ? 1 : -1 });
        currentProject.configurations.forEach(function (configuration) {

            var configurationNode = Y.Node.create("<li>");

            if (currentConfiguration.data.id === configuration.data.id) {
                configurationNode.addClass("is-active");
            }

            configurationNode.setAttribute("data-id", configuration.data.id);

            var configurationWrapper = Y.Node.create("<div>");
            var configurationThumbnailWrapper = Y.Node.create("<span>");
            configurationThumbnailWrapper.setStyle("background-image", "url('" + configuration.data.thumbnail + "')");

            var deleteIconElem = Y.Node.create("<a>");
            deleteIconElem.addClass("configuratior-selector__delete");
            var deleteIconInnerElem = Y.Node.create("<i>");
            deleteIconInnerElem.addClass("fas fa-trash-can");

            deleteIconElem.appendChild(deleteIconInnerElem);
            configurationThumbnailWrapper.appendChild(deleteIconElem);

            configurationWrapper.appendChild(configurationThumbnailWrapper)
            configurationNode.appendChild(configurationWrapper);

            listNode.appendChild(configurationNode);

        });

        if (currentProject.configurations.length < 4) {
            var configurationNode = Y.Node.create("<li>");
            configurationNode.addClass("is-new");

            var configurationWrapper = Y.Node.create("<div>");
            var configurationThumbnailWrapper = Y.Node.create("<span>");
            configurationThumbnailWrapper.setHTML("<i class='fas fa-plus-circle fa-2x'></i>");
            configurationWrapper.appendChild(configurationThumbnailWrapper);
            configurationNode.appendChild(configurationWrapper);
            listNode.appendChild(configurationNode);
        }
    }

    let filterMaterials = function (materials: Material[]) {

        let filters = document.querySelectorAll(".materialfilter");

        materialFilters = [];

        let filteredMaterials = [] as Material[];
        filters.forEach(filter => {
            let inputElement = (filter as HTMLInputElement);

            /*if (inputElement.type === "text") {
                materials.filter(x => x.name)

                materialFilters.push({ key: "search", value: inputElement.value } as MaterialFilter);
            }*/

            if (inputElement.type === "checkbox") {
                if (inputElement.checked)
                    materialFilters.push({ key: "type", value: inputElement.value } as MaterialFilter);
            }
        });

        let typeFilters = materialFilters.filter(y => y.key === "type");

        filteredMaterials = materials.filter(x => {
            return typeFilters.some(y => y.value.toLowerCase() === x.type.toLowerCase())
        });

        /*  let searchFilter = materialFilters.find(x => x.key === "search");
           if (searchFilter.value !== "") {
               filteredMaterials = filteredMaterials.filter(x => x.name.toLowerCase().indexOf(searchFilter.value.toLowerCase()) > 0);
           }*/

        return filteredMaterials;

    }

    let updateMaterialGroupModal = function () {

        let listNode = Y.one(".material-group-modal .modal-card-body ul");
        listNode.empty();

        let searchField = Y.one("#materialsearchfilter");
        let searchFilter = searchField.get("value");


        var currentMaterial = materialLibrary.getMaterialByProductNumber(currentConfiguration.data["material"]);
        var materialGroups = materialLibrary.getMaterialGroups();

        Y.Array.each(materialGroups, function (materialGroup) {

            var groupMaterials = materialLibrary.getMaterialsByGroup(materialGroup);

            groupMaterials = filterMaterials(groupMaterials);

            if (groupMaterials.length > 0) {

                if (searchFilter === "" || materialGroup.toLowerCase().includes(searchFilter)) {


                    var groupMaterial = groupMaterials[0];

                    var materialGroupNode = Y.Node.create("<li>");
                    materialGroupNode.setAttribute("data-group", materialGroup);

                    if (currentMaterial) {
                        if (currentMaterial.group === materialGroup) {
                            materialGroupNode.addClass("is-active");
                        }
                    }

                    var materialGroupContentNode = Y.Node.create("<div class='material-group-content'>");

                    var materialGroupImageNode = Y.Node.create("<div class='material-group-image'>");
                    materialGroupImageNode.setStyle("background-image", "url('" + AppSettings.Paths.BaseMaterialsPath + groupMaterial.type + "/" + groupMaterial.group + "/" + groupMaterial.productNumber + "_thumb.jpg')");

                    var materialGroupNameNode = Y.Node.create("<div class='material-group-name'>");
                    materialGroupNameNode.setHTML(materialGroup);

                    var materialGroupInfoNode = Y.Node.create("<div class='material-group-info'>");
                    materialGroupInfoNode.setHTML("(" + groupMaterials.length + " colors)");

                    materialGroupContentNode.appendChild(materialGroupImageNode);
                    materialGroupContentNode.appendChild(materialGroupNameNode);
                    materialGroupContentNode.appendChild(materialGroupInfoNode);
                    materialGroupNode.appendChild(materialGroupContentNode);

                    listNode.appendChild(materialGroupNode);
                }
            }
        });
    }

    let showSeriesWizardStep = function (stepname: string) {

        Y.all(".series-selection .wizard-nav__stepviews .wizard-nav__stepview").each(function (stepview) {
            stepview.removeClass("is-shown");
        });

        var stepview = Y.one(".series-selection .wizard-nav__stepviews .wizard-nav__stepview[data-stepview='" + stepname + "']");
        stepview.addClass("is-shown");
    }

    let renderProject = async function () {

        return new Promise((resolve) => {

            let series = seriesLibrary.getSeriesByName(currentConfiguration.series);

            Promise.all([
                seriesLibrary.fetchSeriesByID(series.id),
                productLibrary.fetchProducts(series.id)
            ]).then(() => {

                var selectedMaterial = materialLibrary.getMaterialByProductNumber(currentConfiguration.data["material"]);
                if (selectedMaterial) {
                    productSelector.material = selectedMaterial;
                    productSelector.selectedCategory = productLibrary.productsCategories.filter(function (pc) { return pc.products })[0];

                    /*     optionsSelector.reset();
                         optionsSelector.setSeries(series);                   
                         optionsSelector.setupMockData();
                         optionsSelector.setConfiguration(currentConfiguration);
                         optionsSelector.update();*/

                    materialSelector.setConfiguration(currentConfiguration);
                    materialSelector.setMaterialGroup(selectedMaterial.group);
                    materialSelector.update();
                }

                productSelector.update();
                updateConfigurationSelector();

                //  Metrics.ClearMetrics(scene, rulerGUI);

                displaySummaryMenu(true);

                if (!rendererInitialized) {
                    initRenderer().then(() => {
                        resolve(true);
                    });
                } else {
                    resolve(true);
                }

                showPage("viewport");


            });
        });

    }

    let updateOptionsModal = function () {
        var optionsModalOptions = Y.one(".modals .options-modal .options");
        var series = seriesLibrary.getSeriesByName(currentConfiguration.series);
        var summaryList = moduleHelper.generateModuleSummaryList(currentModule, currentConfiguration);

        optionsModalOptions.empty();

        series.customOptions.forEach(option => {
            var row = Y.Node.create("<div>");
            row.addClass("field mt-5");

            let label = Y.Node.create("<label>");
            let controlHolder = Y.Node.create("<div>")

            label.addClass("label")
            label.setHTML(option.name);

            controlHolder.addClass("control");
            var selection = currentConfiguration.data.customOptions?.find(e => e.id == option.id);

            if(option.perModule){
                summaryList.elements.forEach(element => {
                    //var product = productLibrary.getProductByProductNo(element.productNo);
                    const elementSelection = element.extras?.find(e => e.optionId == option.id);
                    const validValues = option.options.filter(o => o.priceLists.some(p => p.items.includes(element.variantName)));

                    if(validValues.length > 0){
                        const p = Y.Node.create("<p>");
                        p.addClass("mt-5");

                        const elementLabel = Y.Node.create("<label>");
                        elementLabel.appendChild(element.variantName);

                        p.appendChild(elementLabel);
                        p.appendChild(Y.Node.create("<br>"));

                        validValues.forEach(v => {
                            let pricelist = v.priceLists.find(p => p.items.includes(element.variantName));
                            let controlLabel = Y.Node.create("<label>")
                            controlLabel.addClass("checkbox");
        
                            let input = Y.Node.create("<input>");
                            input.setAttribute("type", "checkbox");
        
                            if (elementSelection && elementSelection.optionValue == v.id) {
                                input.setAttribute("checked", "checked");
                            }
        
                            input.setData("element", element.entity);
                            input.setData("option", option.id);
                            input.setData("value", v.id);
        
                            controlLabel.appendChild(input);
                            controlLabel.appendChild("&nbsp;" + pricelist.name);
        
                            p.appendChild(controlLabel);
                        });
                        
                        controlHolder.appendChild(p);
                    }
                });
            }else{
                if (option.options.length == 1) {
                    let controlLabel = Y.Node.create("<label>")
                    controlLabel.addClass("checkbox");

                    let input = Y.Node.create("<input>");
                    input.setAttribute("type", "checkbox");

                    if (selection && selection.value == option.options[0].id) {
                        input.setAttribute("checked", "checked");
                    }

                    input.setData("option", option.id);
                    input.setData("value", option.options[0].id);

                    controlLabel.appendChild(input);
                    controlLabel.appendChild("&nbsp;" + option.options[0].name);

                    controlHolder.appendChild(controlLabel);
                } else if (option.options.length > 1) {
                    let selectHolder = Y.Node.create("<div>");
                    selectHolder.addClass("select")
                    let select = Y.Node.create("<select>");

                    select.setData("option", option.id);

                    if(!option.options.some(e => e.id == "")){
                        let defaultOption = Y.Node.create("<option>")
                        defaultOption.setHTML("Standard");
                        defaultOption.setAttribute("value", "-");
                        select.appendChild(defaultOption);
                    }

                    option.options.forEach(option => {
                        let optionElem = Y.Node.create("<option>")
                        optionElem.setHTML(option.name);
                        optionElem.setAttribute("value", option.id);

                        if (selection && selection.value == option.id) {
                            optionElem.setAttribute("selected", "selected");
                        }

                        select.appendChild(optionElem);
                    });

                    selectHolder.appendChild(select);
                    controlHolder.appendChild(selectHolder);
                }
            }

            row.appendChild(label)
            row.appendChild(controlHolder)

            optionsModalOptions.appendChild(row);
        });
    }

    let updateSummary = function () {
        if (errorHandler.errors.length === 0) {

            var series = seriesLibrary.getSeriesByName(currentConfiguration.series)
            var leg = undefined;
            var legThumb = seriesLibrary.getLegThumbnail(series, "standard", "LT01");

            var standardLeg = series.legPackages.find(e => e.type === "Standard");

            if(standardLeg){
                let validLegs = series.legPackages;
                const legDesign = currentConfiguration.data.customOptions.find(e => e.id == "Leg, design variation");
                const legHeight = currentConfiguration.data.customOptions.find(e => e.id == "Leg height");

                if(legDesign){
                    validLegs = validLegs.filter(e => e.surface !== standardLeg.surface);
                }
                if(legHeight){
                    if(legHeight.value.includes("+2")){
                        validLegs = validLegs.filter(e => e.type.includes("+2"));
                    }
                    if(legHeight.value.includes("+4")){
                        if(validLegs.some(e => e.type.includes("+4"))){
                            validLegs = validLegs.filter(e => e.type.includes("+4"));
                        }else{
                            validLegs = validLegs.filter(e => e.type.includes("+2"));
                        }
                    }
                }

                if(validLegs.length > 0){
                    leg = seriesLibrary.getSeriesLeg(series, validLegs[0].type, "LT01");
                }
            }

            var summaryList = moduleHelper.generateModuleSummaryList(currentModule, currentConfiguration);
            var totalPrice = moduleHelper.getTotalModulePrice(currentModule, currentConfiguration);
            var options = [];

            series.customOptions.forEach(optionGroup => {
                var selection = currentConfiguration.data.customOptions?.find(e => e.id == optionGroup.id);

                optionGroup.options.forEach(option => {
                    if (selection != undefined && selection.value == option.id) {
                        options.push(option.name);
                    }
                });
            })

            if (summaryList.elements.length > 0 || summaryList.accessories.length > 0) {

                let currentMaterial = materialLibrary.getMaterialByProductNumber(currentConfiguration.data.material) as Material;

                let summarySeriesImage = Y.one(".summary-page .summary__description--image .summary-image");
                summarySeriesImage.setAttribute("src", currentConfiguration.image);

                let summarySeriesThumbnail = Y.one(".summary-page .summary__description--series .summary-image");
                summarySeriesThumbnail.setAttribute("src", currentConfiguration.data.thumbnail);

                let summarySeriesValue = Y.one(".summary-page .summary__description--series .summary__description--value span");
                summarySeriesValue.setHTML(currentConfiguration.series);

                let summaryMaterialImage = Y.one(".summary-page .summary__description--material .summary-image");
                summaryMaterialImage.setAttribute("src", materialLibrary.getMaterialThumbnailUrl(currentMaterial.productNumber));

                let summaryMaterialValue = Y.one(".summary-page .summary__description--material .summary__description--value span");
                summaryMaterialValue.setHTML(currentMaterial.name);

                let summaryLegsImage = Y.one(".summary-page .summary__description--legs .summary-image");
                summaryLegsImage.setAttribute("src", legThumb);

                let summaryLegsValue = Y.one(".summary-page .summary__description--legs .summary__description--value span");
                summaryLegsValue.setHTML(leg?.name ?? "");

                let summaryOptionsValue = Y.one(".summary-page .summary__description--options .summary__description--value span");
                summaryOptionsValue.setHTML(options.join("<br />"));

                let summaryDrawingImage = Y.one(".summary-page .summary__description--drawing .summary-image");
                summaryDrawingImage.setAttribute("src", currentConfiguration.drawing);


                let summaryActionsConfigNumber = Y.one(".summary-page .summary__actions .summary__actions__confignumber--value");
                summaryActionsConfigNumber.setHTML(currentProject.identifier.toUpperCase());

                let summaryProductList = Y.one(".summary-page .summary__products .summary__table__rows");
                let summaryProductListBody = summaryProductList.one("tbody");
                let summaryProductListFooter = summaryProductList.one("tfoot");

                let currency = summaryList.elements[0].currency;

                summaryProductListBody.empty();
                summaryList.elements.forEach(summaryItem => {

                    var row = Y.Node.create("<tr>");

                    var product = productLibrary.getProductByProductNo(summaryItem.productNo);

                    let cellProductNameNode = Y.Node.create("<td>");
                    let cellProductDimensionNode = Y.Node.create("<td>");
                    let cellProductNumberNode = Y.Node.create("<td>");
                    let cellProductAmountNode = Y.Node.create("<td>");
                    let cellProductPriceNode = Y.Node.create("<td>");

                    cellProductNameNode.setHTML(product.name);
                    cellProductDimensionNode.setHTML(ProductHelper.getFormattedString(product, ['width', 'depth', 'height']));
                    cellProductNumberNode.setHTML(`${summaryItem.axProductNo} - ${summaryItem.variantProductNo}`);
                    cellProductAmountNode.setHTML(`${summaryItem.amount} stk`);
                    cellProductPriceNode.setHTML(`${FormatHelper.formatNumber(summaryItem.price)} ${currency}`);

                    row.appendChild(cellProductNameNode)
                    row.appendChild(cellProductDimensionNode)
                    row.appendChild(cellProductNumberNode)
                    row.appendChild(cellProductAmountNode)
                    row.appendChild(cellProductPriceNode)

                    summaryProductListBody.appendChild(row);

                    summaryItem.extras.forEach(extra => {
                        var row = Y.Node.create("<tr>");

                        let cellProductNameNode = Y.Node.create("<td>");
                        let cellProductDimensionNode = Y.Node.create("<td>");
                        let cellProductNumberNode = Y.Node.create("<td>");
                        let cellProductAmountNode = Y.Node.create("<td>");
                        let cellProductPriceNode = Y.Node.create("<td>");

                        cellProductNameNode.setHTML();
                        cellProductDimensionNode.addClass("pl-6");
                        cellProductDimensionNode.setHTML(extra.name);
                        cellProductNumberNode.setHTML(extra.productNo);
                        cellProductAmountNode.setHTML();
                        cellProductPriceNode.setHTML(`${FormatHelper.formatNumber(extra.price)} ${currency}`);

                        row.appendChild(cellProductNameNode);
                        row.appendChild(cellProductDimensionNode);
                        row.appendChild(cellProductNumberNode);
                        row.appendChild(cellProductAmountNode);
                        row.appendChild(cellProductPriceNode);

                        summaryProductListBody.appendChild(row);
                    })

                });

                summaryList.customOptions.forEach(customOption => {

                    var row = Y.Node.create("<tr>");

                    let cellProductNameNode = Y.Node.create("<td>");
                    let cellProductDimensionNode = Y.Node.create("<td>");
                    let cellProductNumberNode = Y.Node.create("<td>");
                    let cellProductAmountNode = Y.Node.create("<td>");
                    let cellProductPriceNode = Y.Node.create("<td>");

                    cellProductNameNode.setHTML(customOption.productNo);
                    cellProductDimensionNode.setHTML("");
                    cellProductNumberNode.setHTML(customOption.name);
                    cellProductAmountNode.setHTML(`${customOption.amount} stk`);
                    cellProductPriceNode.setHTML(`${FormatHelper.formatNumber(customOption.totalprice)} ${currency}`);

                    row.appendChild(cellProductNameNode)
                    row.appendChild(cellProductDimensionNode)
                    row.appendChild(cellProductNumberNode)
                    row.appendChild(cellProductAmountNode)
                    row.appendChild(cellProductPriceNode)

                    summaryProductListBody.appendChild(row);
                });


                let summaryAddOnList = Y.one(".summary-page .summary__accessories .summary__accessories__list");
                let summaryAddOnListBody = summaryAddOnList.one("tbody");
                let summaryAddOnListFooter = summaryAddOnList.one("tfoot");

                summaryAddOnListBody.empty();
                series.accessories.forEach(addOn => {

                    var row = Y.Node.create("<tr>");
                    var amount = summaryList.accessories.find(e => e.productNo == addOn.productNumber)?.amount ?? 0;
                    var price = addOn.priceLists[0]?.prices[currentMaterial.priceGroup] ?? 0;

                    let cellProductNameNode = Y.Node.create("<td>");
                    let cellProductNumberNode = Y.Node.create("<td>");
                    let cellProductAmountNode = Y.Node.create("<td>");
                    let cellProductPriceNode = Y.Node.create("<td>");
                    let cellProductTotalPriceNode = Y.Node.create("<td>");
                    let amountInput = Y.Node.create("<input>");
                    let amountLabel = Y.Node.create("<span>");

                    amountInput.setAttribute("type", "number");
                    amountInput.setAttribute("value", amount);
                    amountInput.setAttribute("min", "0");
                    amountInput.setData("product", addOn.productNumber);
                    amountInput.addClass("addon-amount");

                    cellProductNameNode.setHTML(addOn.name);
                    cellProductNumberNode.setHTML(addOn.productNumber);
                    amountLabel.setHTML(' stk');
                    cellProductPriceNode.setHTML(`${price} ${currency}`);
                    cellProductTotalPriceNode.setHTML(`${FormatHelper.formatNumber(price * amount)} ${currency}`);

                    row.appendChild(cellProductNameNode)
                    row.appendChild(cellProductNumberNode)
                    cellProductAmountNode.appendChild(amountInput)
                    cellProductAmountNode.appendChild(amountLabel)
                    row.appendChild(cellProductAmountNode)
                    row.appendChild(cellProductPriceNode)
                    row.appendChild(cellProductTotalPriceNode)

                    summaryAddOnListBody.appendChild(row);
                });

                summaryAddOnListFooter.empty();
                var row = Y.Node.create("<tr>");

                let cellSpacer = Y.Node.create("<td>");
                cellSpacer.setAttribute("colspan", "3");

                let cellProductTotal = Y.Node.create("<td>");
                cellProductTotal.setHTML(`<b>Total</b>`);

                let cellProductTotalPrice = Y.Node.create("<td>");
                cellProductTotalPrice.setHTML(`<b>${FormatHelper.formatNumber(totalPrice.totalPrice)} ${totalPrice.currency}</b>`);

                row.appendChild(cellSpacer)
                row.appendChild(cellProductTotal)
                row.appendChild(cellProductTotalPrice)

                summaryAddOnListFooter.appendChild(row);
            }
        }
    }

    /**
     * UI/UX Functions
     * */

    //Series List
    let seriesList = new window.freewall('.series-list');
    seriesList.reset({
        selector: '.tile-list-item',
        animate: false,
        delay: 0.2,
        gutterY: 20,
        gutterX: 20,
        cellW: function (width) {

            var cellWidth = width;
            if (width >= 600) {
                cellWidth = width / 2;
            }
            if (width >= 1000) {
                cellWidth = width / 3;
            }
            return cellWidth;
        },
        cellH: function (height) {
            return height;
        },
        onResize: function () {
            this.fitWidth();
        }
    });

    //Preset list
    let presetList = new window.freewall('.preset-list');
    presetList.reset({
        selector: '.tile-list-item',
        animate: false,
        delay: 0.2,
        gutterY: 20,
        gutterX: 20,
        cellW: function (width) {

            var cellWidth = width;
            if (width >= 600) {
                cellWidth = width / 2;
            }
            if (width >= 1000) {
                cellWidth = width / 3;
            }
            return cellWidth;
        },
        cellH: function (height) {
            return height;
        },
        onResize: function () {
            this.fitWidth();
        }
    });

    let displaySummaryMenu = function (isShown: boolean) {

        var summaryMenu = Y.one(".summary-menu");

        if (isShown) {
            summaryMenu.addClass("is-active");
        } else {
            summaryMenu.removeClass("is-active");
        }
    }


    //Pagenation
    Y.one("body").delegate("click", async function (evt) {

        projectFilter.currentPage += 1;
        if (projectFilter.currentPage > Math.ceil(projectLibrary.count / projectFilter.itemsShown))
            projectFilter.currentPage = Math.ceil(projectLibrary.count / projectFilter.itemsShown);

        await updateProjectsList();

    }, ".pagenation button.next");

    Y.one("body").delegate("click", async function (evt) {

        projectFilter.currentPage -= 1;
        if (projectFilter.currentPage < 1)
            projectFilter.currentPage = 1;

        await updateProjectsList();

    }, ".pagenation button.prev");

    Y.one("body").delegate("click", async function (evt) {

        projectFilter.currentPage = Math.ceil(projectLibrary.count / projectFilter.itemsShown);
        await updateProjectsList();

    }, ".pagenation button.last");

    Y.one("body").delegate("click", async function (evt) {

        projectFilter.currentPage = 1;
        await updateProjectsList();

    }, ".pagenation button.first");

    Y.one("body").delegate("click", async function (evt) {

        let identifierElem = Y.one(".openconfig-identifier input");
        let identifier = identifierElem.get("value");

        if (identifier) {

            let project = await projectLibrary.getProject(identifier);
            currentProject = project;
            currentConfiguration = project.configurations[0];
            currentModule = currentConfiguration.data.modules[0];

            showLoader();

            seriesLibrary.fetchSeriesByName(currentConfiguration.series).then((series) => {

                var defaultLeg = seriesLibrary.getSeriesLeg(series, "standard");

                // currentConfiguration.data.options["defaultLeg"] = series.defaultLeg;
                currentConfiguration.data.options["leg"] = currentConfiguration.data.options["leg"] || defaultLeg.productNumber;

                materialLibrary.defaultMaterial = series.defaultMaterial;
                materialLibrary.materials = series.materials;

                renderProject().then(() => {
                    constructModule(currentModule);
                });
            });

        }//

    }, ".landing-page .openconfig-button");

    Y.one("body").delegate("click", async function (evt) {

        let project = {} as Project;
        project.seller = "";
        project.name = "";
        project.phone = "";
        project.status = 1;
        project.configurations = [];

        currentProject = project;
        isNewConfig = true;

        //showLoader();
        /* projectLibrary.createProject(project).then((newProject) => {
             currentProject = newProject;
             showPage("series");
             hideLoader();
         });*/

        showPage("series");

    }, ".landing-page .createconfig-button");

    let enableAllProducts = function () {
        Y.all(".menu .menu__item__content > ul > li").each(function (productElement) {
            productElement.setAttribute("disabled", "");
            productElement.removeClass("disabled");
        });
    }

    Y.one("body").delegate("click", function (e: any) {

        var elem = e.currentTarget;
        var configMenuElem = elem.ancestor(".config-menu");
        var viewportElem = Y.one(".viewport");
        configMenuElem.toggleClass("is-collapsed");
        viewportElem.toggleClass("is-menu-collapsed");
        engine.resize();

    }, ".config-menu .config-menu__close");

    Y.one("body").delegate("click", function (e: any) {

        //Reset selected menu
        var activeMenu = Y.one(".config-menu .config-menu__submenu-selection ul li[data-menu].is-active")
        activeMenu.removeClass("is-active");
        var menu = activeMenu.getData("menu");
        var menuview = Y.one(".config-menu .config-menu__submenues__submenu[data-menuview='" + menu + "']");
        menuview.removeClass("is-shown");

        //Set selected menu
        var elem = e.currentTarget;
        elem.addClass("is-active");
        menu = elem.getData("menu");
        menuview = Y.one(".config-menu .config-menu__submenues__submenu[data-menuview='" + menu + "']");
        menuview.addClass("is-shown");

        switch (menu) {
            case "modules": {
                productSelector.reset();
                productSelector.update();
            }
                break;
            /* case "customize": {
                 optionsSelector.reset();
                 optionsSelector.update();
             }
                 break;*/
        }


    }, ".config-menu .config-menu__submenu-selection ul li[data-menu]");

    Y.one("body").delegate("click", async function (e: any) {

        var elem = e.currentTarget;

        let seriesId = parseInt(elem.getData("series"));

        seriesLibrary.fetchSeriesByID(seriesId).then(() => {

            var series = seriesLibrary.getSeriesById(seriesId);

            //Create configuration
            createProjectConfiguration(currentProject, series.name);

            //Set default legs for series
            var defaultLeg = seriesLibrary.getSeriesLeg(series, "standard");

            // currentConfiguration.data.options["defaultLeg"] = series.defaultLeg;
            currentConfiguration.data.options["leg"] = defaultLeg.productNumber;
            //   window.dispatchEvent(new Event("saveconfigurations"));

            materialLibrary.defaultMaterial = series.defaultMaterial;
            materialLibrary.materials = series.materials;

            updatePresetList();
            showSeriesWizardStep("preset");
        });

    }, ".series-list .tile-list-item");

    Y.one("body").delegate("click", async function (e: any) {

        showLoader();

        if (isNewConfig) {
            await projectLibrary.createProject(currentProject).then((newProject) => {
                currentProject = newProject;
                //showPage("series");
                // hideLoader();
                // window.dispatchEvent(new Event("saveconfigurations"));

                /* renderProject().then(() => {
                     mainCamera.radius = initialCameraRadius;
                     hideLoader();
                 });*/
            });
        } else {
            window.dispatchEvent(new Event("saveconfigurations"));

        }

        renderProject().then(() => {
            mainCamera.radius = initialCameraRadius;
            hideLoader();
        });

    }, ".preset-list .tile-list-item.is-new");

    Y.one("body").delegate("click", function (e: any) {
        renderDrawingWithGUI(currentConfiguration, () => {
            renderConfigurationImage(currentConfiguration, (image) => {
                currentConfiguration.image = image;
                updateSummary();
            });
        });
        showPage("summary");
    }, ".summary-menu__button");

    Y.one("body").delegate("change", function (e: any) {
        const amount = Math.max(0, e.target.get("value"));
        const productNo = e.target.getData("product");

        const summary = moduleHelper.generateModuleSummaryList(currentModule, currentConfiguration);
        const summaryItem = summary.accessories.find(e => e.productNo == productNo);

        const dif = amount - (summaryItem?.amount ?? 0);

        if (!currentConfiguration.data.addons) {
            currentConfiguration.data.addons = []
        }

        let addOnItem = currentConfiguration.data.addons.find(e => e.productNo == productNo);
        if (!addOnItem) {
            addOnItem = {
                amount: 0,
                productNo: productNo
            }
            currentConfiguration.data.addons.push(addOnItem);
        }
        addOnItem.amount += dif;

        updateSummary();
    }, ".summary__accessories__list .addon-amount");

    Y.one("body").delegate("change", function(e: any) {

        var terms = Y.one(".summary__actions__terms input");
        var disclaimer =  Y.one(".summary__actions__disclaimer input");
        var orderButton = Y.one(".order-button");

        if (terms.get("checked") && disclaimer.get("checked")) {           
             orderButton.set("disabled","")
        } else {
            orderButton.set("disabled","disabled")
        }

    }, ".summary__actions__terms input, .summary__actions__disclaimer input");

    Y.one("body").delegate("click", function (e: any) {

        var terms = Y.one(".summary__actions__terms input");
        var disclaimer =  Y.one(".summary__actions__disclaimer input");

        if (terms.get("checked") && disclaimer.get("checked")) {
            window.dispatchEvent(new Event("saveconfigurations"));
            pdfHandler.generatePDF(currentProject, currentConfiguration, moduleHelper, currentModule);

            var orderModal = Y.one(".modals .order-modal");
            orderModal.addClass("is-active");
        }

    }, ".order-button");


    Y.one("body").delegate("click", function (e: any) {

        switch (currentPage) {

            case "configurations": {
                showPage(previousPage);
            }
                break;
            case "summary": {
                showPage("viewport");
            }
                break;
        }

    }, ".back-button");

    Y.one("body").delegate("click", function (e: any) {

        var elem = e.currentTarget;
        var modal = elem.ancestor(".modal");
        modal.removeClass("is-active");

    }, ".modal-card-close, .modal-close");


    Y.one("body").delegate("click", function (e: any) {

        e.preventDefault();

        Y.all(".configuration-selector ul li").each(function (e) {
            e.removeClass("is-active");
        });

        var elem = e.currentTarget;
        elem.addClass("is-active");

        var configurationId = elem.getData("id");

        if (currentConfiguration.data.id !== configurationId) {

            //clearConfigurationAssets();
            cleanupAssets();

            currentConfiguration = projectLibrary.getConfiguration(currentProject, configurationId);;

            seriesLibrary.fetchSeriesByName(currentConfiguration.series).then(series => {
                productLibrary.fetchProducts(series.id).then(() => {
                    let currentMaterial = materialLibrary.getMaterialByProductNumber(currentConfiguration.data["material"]);
    
                    productSelector.material = currentMaterial;
                    productSelector.reset();
                    //productSelector.categories = [];
                    productSelector.update();
    
                    materialSelector.setConfiguration(currentConfiguration);
                    materialSelector.setMaterialGroup(currentMaterial.group);
                    materialSelector.update();
    
                    /* optionsSelector.reset();
                     optionsSelector.setSeries(series);
                     optionsSelector.setupMockData();
                     optionsSelector.setConfiguration(currentConfiguration);
                     optionsSelector.update();*/
    
                    currentModule = currentConfiguration.data.modules[0];
                    constructModule(currentModule).then(() => {
                        resetMainCamera();
                        fitView(currentModuleNode, mainCamera, false);
                    });
                });
            });
        }

    }, ".configuration-selector ul li[data-id]");

    Y.one("body").delegate("click", function (e: any) {

        e.preventDefault();

        var elem = e.currentTarget;
        var parent = elem.ancestor("li");
        var configurationId = parent.getData("id");

        var removeableConfiguration = projectLibrary.getConfiguration(currentProject, configurationId);

        var configIndex = currentProject.configurations.indexOf(removeableConfiguration);
        if (configIndex > 0) {
            configIndex = configIndex - 1;
        }    

        if (currentProject.configurations.length > 0) {

            currentConfiguration = currentProject.configurations[configIndex];

            let series = seriesLibrary.getSeriesByName(currentConfiguration.series);
            var currentMaterial = materialLibrary.getMaterialByProductNumber(currentConfiguration.data["material"]);

            //  clearConfigurationAssets();
            cleanupAssets();

            productLibrary.fetchProducts(series.id).then(() => {
                productSelector.material = currentMaterial;
                productSelector.reset();
                //productSelector.categories = [];
                productSelector.update();

                materialSelector.setConfiguration(currentConfiguration);
                materialSelector.setMaterialGroup(currentMaterial.group);
                materialSelector.update();

                /*  optionsSelector.reset();
                  optionsSelector.setSeries(series);
                  optionsSelector.setupMockData();
                  optionsSelector.setConfiguration(currentConfiguration);
                  optionsSelector.update();*/

                currentModule = currentConfiguration.data.modules[0];
                constructModule(currentModule);

                /* currentConfiguration.data.modules.forEach(function (m) {
                     constructModule(m);
                 });*/

                updateConfigurationSelector();
            });

            projectLibrary.deleteConfiguation(currentProject, removeableConfiguration);
        } else {
            showPage("series");
        }

        //  window.dispatchEvent(new Event("saveconfigurations"));

    }, ".configuration-selector ul li[data-id] a");

    Y.one("body").delegate("click", function (e: any) {

        showPage("series");
        productSelector.reset();
        productSelector.update();
        resetMainCamera();

    }, ".configuration-selector ul li.is-new");

    /* Y.one("body").delegate("click", function (e: any) {
 
         clearConfigurationAssets();
 
         scene.getNodeById("products").getChildren(null, false).forEach(function (p) {
             p.dispose(false, true);
         });
 
     }, ".clear");*/

    Y.one("body").delegate("change", function (e: any) {

        projectFilter.hideInactive = e.currentTarget.get("checked");
        updateProjectsList();

    }, "#hideinactive-projects");

    Y.one("body").delegate("keyup", debounce(function (e: any) {
        projectFilter.search = e.currentTarget.get("value");
        updateProjectsList();
    }, 250), "#projectsearch");

    Y.one("body").delegate("reset", function (e: any) {
        projectFilter.search = "";
        updateProjectsList();
    }, ".projectsearch form");


    Y.one("body").delegate("click", function (e: any) {

        let contextMenues = Y.all(".project-actions");
        contextMenues.removeClass("is-active");

        let target = e.currentTarget;
        let parent = target.ancestor(".dropdown");
        parent.addClass("is-active");

        target.on("clickoutside", function (e: any) {
            let contextMenues = Y.all(".project-actions");
            contextMenues.removeClass("is-active");
        });


        /* let target = e.currentTarget;
         let parent = target.ancestor();
         let identifier = target.getData("id");
 
         let contextMenues = Y.all(".contextmenu");
         contextMenues.remove();            
 
         target.on("clickoutside", function (e: any) {           
             let contextMenues = Y.all(".contextmenu");
             contextMenues.remove();            
         });
 
         let contextMenu = Y.Node.create("<div class='contextmenu box'></div>");
         let contextMenuItems = Y.Node.create("<ul>");
 
         let openConfig = Y.Node.create("<li><span>Open Config</span><span class='icon is-small'><i class='fas fa-long-arrow-right'></i></span></li>");
 
         openConfig.on("click", async function (e: any) {
             e.preventDefault(); 
 
             if (identifier) {
 
                 let project = await projectLibrary.getProject(identifier);
                 currentProject = project;
                 currentConfiguration = project.configurations[0];
 
                 if (!currentConfiguration)
                     return false;                    
 
                 currentModule = currentConfiguration.data.modules[0];
 
                 showLoader();
 
                 let seriesData = await seriesLibrary.fetchSeries();
                 let promises = [] as Promise<Series>[];
                 seriesData.forEach((series) => {
                     promises.push(seriesLibrary.fetchSeriesByID(series.id));
                 });
 
                 Promise.all(promises).then(() => {
 
                     //seriesLibrary.fetchSeries().then(function () {
 
                     let series = seriesLibrary.getSeriesByName(currentConfiguration.series);
 
                     seriesLibrary.fetchSeriesByID(series.id).then(() => {
 
                         var defaultLeg = seriesLibrary.getSeriesLeg(series, "standard");
 
                         // currentConfiguration.data.options["defaultLeg"] = series.defaultLeg;
                         currentConfiguration.data.options["leg"] = currentConfiguration.data.options["leg"] || defaultLeg.productNumber;
 
                         materialLibrary.defaultMaterial = series.defaultMaterial;
                         materialLibrary.materials = series.materials;
 
                         renderProject().then(() => {
                             constructModule(currentModule);
                         });
                     });
 
                 });
             }            
         });
 
 
         let editProject = Y.Node.create("<li><span>Edit info</span><span class='icon is-small'><i class='fas fa-cog'></i></span></li>");
 
         editProject.on("click", async function (e: any) {
 
             let editProjectModal = Y.one(".editproject-modal");
             editProjectModal.addClass("is-active");
 
             let projectIdentifierElem = Y.one("#project-identifier");
             let projectNameElem = Y.one("#project-name");
             let projectPhoneElem = Y.one("#project-phone");
             let projectEmailElem = Y.one("#project-email");
             let projectStatusElem = Y.one("#project-status");
             let projectAddedElem = Y.one("#project-added");
             let projectModifiedElem = Y.one("#project-modified");
 
             let project = await projectLibrary.getProject(identifier);
             currentProject = project;
 
             projectIdentifierElem.setHTML(project.identifier);
             projectNameElem.set("value", project.name);
             projectPhoneElem.set("value", project.phone);
             projectEmailElem.set("value", project.seller);
 
             projectStatusElem.set("value", project.status);
 
             projectAddedElem.setHTML(DateHelper.formatDate(project.added));
             projectModifiedElem.setHTML(DateHelper.formatDate(project.modified));
         });
 
         contextMenuItems.appendChild(openConfig);
         contextMenuItems.appendChild(editProject);
         contextMenu.appendChild(contextMenuItems);
 
         parent.appendChild(contextMenu);
 
         */

        e.preventDefault();
        e.stopPropagation();

    }, ".project-actions .dropdown-trigger");

    Y.one("body").delegate("click", async function (e: any) {

        let target = e.currentTarget;
        let identifier = target.getData("id");

        if (identifier) {
            let editProjectModal = Y.one(".editproject-modal");
            editProjectModal.addClass("is-active");

            let projectIdentifierElem = Y.one("#project-identifier");
            let projectNameElem = Y.one("#project-name");
            let projectPhoneElem = Y.one("#project-phone");
            let projectEmailElem = Y.one("#project-email");
            let projectStatusElem = Y.one("#project-status");
            let projectAddedElem = Y.one("#project-added");
            let projectModifiedElem = Y.one("#project-modified");

            let project = await projectLibrary.getProject(identifier);
            currentProject = project;

            projectIdentifierElem.setHTML(project.identifier);
            projectNameElem.set("value", project.name);
            projectPhoneElem.set("value", project.phone);
            projectEmailElem.set("value", project.seller);

            projectStatusElem.set("value", project.status);

            projectAddedElem.setHTML(FormatHelper.formatDate(project.added));
            projectModifiedElem.setHTML(FormatHelper.formatDate(project.modified));
        }

    }, ".edit-project");

    Y.one("body").delegate("click", async function (e: any) {

        let target = e.currentTarget;
        let identifier = target.getData("id");

        await openConfig(identifier);

        /*  if (identifier) {
  
              let project = await projectLibrary.getProject(identifier);
              currentProject = project;
              currentConfiguration = project.configurations[0];
  
              if (!currentConfiguration)
                  return false;
  
              if (currentConfiguration.data.modules.length > 0)
                  currentModule = currentConfiguration.data.modules[0];
  
              let seriesData = await seriesLibrary.fetchSeries();
              let promises = [] as Promise<Series>[];
              seriesData.forEach((series) => {
                  promises.push(seriesLibrary.fetchSeriesByID(series.id));
              });
  
              Promise.all(promises).then(() => {
  
                  let series = seriesLibrary.getSeriesByName(currentConfiguration.series);
  
                  seriesLibrary.fetchSeriesByID(series.id).then(() => {
  
                      var defaultLeg = seriesLibrary.getSeriesLeg(series, "standard");
                                        
                      currentConfiguration.data.options["leg"] = currentConfiguration.data.options["leg"] || defaultLeg.productNumber;
  
                      materialLibrary.defaultMaterial = series.defaultMaterial;
                      materialLibrary.materials = series.materials;
  
                      renderProject().then(() => {
                          constructModule(currentModule);
                      });
                  });
  
              });
          } */

    }, ".open-project");

    Y.one("body").delegate("submit", async function (e: any) {

        e.preventDefault();

        // var elem = e.currentTarget;

        //  let parent = elem.ancestor(".contextmenu");
        //  let identifier = parent.getData("id");

        //let projectIdentifierElem = Y.one("#project-identifier");
        let projectNameElem = Y.one("#project-name");
        let projectPhoneElem = Y.one("#project-phone");
        let projectEmailElem = Y.one("#project-email");
        let projectStatusElem = Y.one("#project-status");
        // let projectAddedElem = Y.one("#project-added");
        // let projectModifiedElem = Y.one("#project-modified");

        let projectName = projectNameElem.get("value");
        let projectPhone = projectPhoneElem.get("value");
        let projectEmail = projectEmailElem.get("value");
        let projectStatus = projectStatusElem.get("value");

        currentProject.name = projectName;
        currentProject.phone = projectPhone;
        currentProject.seller = projectEmail;
        currentProject.status = projectStatus;

        await projectLibrary.saveProject(currentProject);
        currentProject = null;

        let editProjectModal = Y.one(".editproject-modal");
        editProjectModal.removeClass("is-active");

        await updateProjectsList();

    }, "#editprojectform");

    Y.one("body").delegate("click", function (e: any) {

        let createProjectModal = Y.one(".createproject-modal");
        createProjectModal.addClass("is-active");

        var newProjectName = createProjectModal.one("#newproject-name");
        newProjectName.set("value", "");

    }, "#newproject-button");

    Y.one("body").delegate("submit", function (e: any) {

        e.preventDefault();

        let projectNameElem = Y.one("#newproject-name");
        let projectPhoneElem = Y.one("#newproject-phone");
        let projectEmailElem = Y.one("#newproject-email");

        let project = {} as Project;
        project.name = projectNameElem.get("value");
        project.phone = projectPhoneElem.get("value");
        project.seller = projectEmailElem.get("value");
        project.status = 1;
        project.configurations = [];

        currentProject = project;
        isNewConfig = true;

        let createProjectModal = Y.one(".createproject-modal");
        createProjectModal.removeClass("is-active");

        showPage("series");

    }, "#createprojectform");

    Y.one("body").delegate("submit", async function (e: any) {

        e.preventDefault();

        var elem = e.currentTarget;
        var input = elem.one("input");
        var identifier = input.get("value");

        await openConfig(identifier);

    }, "#openprojectform");

    Y.one("body").delegate("click", function (e: any) {

        showPage("configurations");

    }, "#projects");

    Y.one("body").delegate("click", function (e: any) {

        handleLogout();

    }, "#logout");

    Y.one("body").delegate("click", function (e: any) {

        var userDropdownTrigger = Y.one(".user-menu__button");
        userDropdownTrigger.addClass("is-black");

        var userDropdown = Y.one(".user-menu__wrapper .dropdown");
        userDropdown.addClass("is-active");

        e.preventDefault();
        e.stopPropagation();

    }, ".user-menu__button");

    Y.one(".user-menu__button").on("clickoutside", function (e: any) {

        var userDropdownTrigger = Y.one(".user-menu__button");
        userDropdownTrigger.removeClass("is-black");

        var userDropdown = Y.one(".user-menu__wrapper .dropdown");
        userDropdown.removeClass("is-active");

    });


    Y.one("body").delegate("click", function (e: any) {

        if (isPlacing)
            return false;

        var elem = e.currentTarget;

        var productNumber = elem.getData("productnumber");
        let product = productLibrary.getProductByProductNo(productNumber);
        // let productVariant = productLibrary.getProduct(productNumber, currentModule, null);
        currentProduct = product;
        instantiateModule(currentConfiguration, currentModule, function (module, moduleNode) {

            currentModule = module;
            currentModuleNode = moduleNode;

            instantiateEntity(module, product, null, function (instantiatedEntity, instantiatedEntityNode) {

                var productVariant = getProductVariant(instantiatedEntity.productNo, instantiatedEntity);
                instantiatedEntity.variantProductNo = productVariant.productNo;
                instantiatedEntityNode.metadata.productNo = productVariant.productNo;

                //Set current selected entity                
                currentEntityNode = instantiatedEntityNode;

                if (currentModule.entities.length == 1) {

                    isPlacing = false;

                    //  var entityConnectionType = moduleHelper.getEntityConnectionType(currentModule, instantiatedEntity);

                    //Create legs
                    constructLegs(currentModule, instantiatedEntity);

                    currentEntityNode.setAbsolutePosition(new BABYLON.Vector3(0, currentEntityNode.position.y, 0));

                    var entityBounds = currentEntityNode.getChildMeshes(true, function (m) { return m.id === "entitybounds" })[0];
                    entityBounds.setEnabled(true);

                    currentEntityNode = null;

                    meshLibrary.loadMeshAsync(productVariant.productNo, instantiatedEntity, productVariant.type, "furniture/", productVariant.model + ".glb", productVariant.isFlipped, scene, false, sg, sg2, onProgress, function (clonedMeshEntityId, clonedMesh) {

                        //HACK! Rotate mesh if connection type CT11
                        //rotateCushions(entityConnectionType, instantiatedEntity, clonedMesh, productVariant);

                        clonedMesh.scaling.x = productVariant.isFlipped ? -1 : 1;
                        clonedMesh.position.y = currentConfiguration.data.offsetY;

                        //Set material
                        let material = materialLibrary.getMaterialByProductNumber(currentConfiguration.data["material"]);
                        if (material) {
                            materialLibrary.assignMaterial(Y, productVariant, [clonedMesh], material, scene, function () {
                                clonedMesh.setEnabled(true);
                            });
                        }

                        hideAllHighlights();
                        hideEntityActions();

                        moveAllEntities(currentModule);
                        refreshModuleBounds(currentModule);
                        validateConstruction(currentModule);

                        displaySummaryButton(true);

                        window.dispatchEvent(new Event("saveconfigurations"));

                        pauseRender();
                        resumeRender().then(() => {

                            window.dispatchEvent(new Event("thumbnail_render"));

                            updateSummaryMenuTotalPrice();

                            mainCamera.attachControl(canvas, true, false);
                            fitView(currentModuleNode, mainCamera, false);

                            hideLoadingCanvas();
                        });

                    });
                } else {
                    isPlacing = true;
                    hideEntityActions();
                    showAvailableConnectors(module, instantiatedEntity)
                    e.preventDefault();
                    e.stopPropagation();
                }
            });
        });
    }, ".config-menu .config-menu__submenues__submenu[data-menuview='modules'] .product-selector .selector__items li");

    Y.one(".viewport").on("clickoutside", function (e: any) {
        if (isPlacing) {

            isPlacing = false;

            var entity = getCurrentEntity();
            if (entity) {
                deleteEntity(entity);
                hideAvailableConnectors();
            }
        }
    })

    Y.one("body").delegate("click", function (e: any) {

        Y.all(".config-menu .config-menu__submenues__submenu[data-menuview='myeilersen'] .options-selector__items ul li").each(function (e) {
            e.removeClass("is-active");
        });

        // optionsSelector.update(optionsSelector.path[optionsSelector.path.length - 1]);

    }, ".config-menu .config-menu__submenues__submenu[data-menuview='myeilersen'] .options-selector__items ul li");

    Y.one("body").delegate("click", function (e) {

        e.preventDefault();

        var materialGroupModal = Y.one(".modals .material-group-modal");
        materialGroupModal.addClass("is-active");

        updateMaterialGroupModal();

    }, ".config-menu .config-menu__submenues__submenu[data-menuview='fabrics'] .material-selector__items .material-selector__items__group__select");

    Y.one("body").delegate("click", function (e) {

        e.preventDefault();

        updateOptionsModal();
        var optionsModal = Y.one(".modals .options-modal");
        optionsModal.addClass("is-active");

    }, ".config-menu .config-menu__customize");

    Y.one("body").delegate("change", function (e) {
        if (currentConfiguration.data.customOptions == undefined) {
            currentConfiguration.data.customOptions = [];
        }

        let input = e.currentTarget;

        let option = input.getData("option");
        let value = input.get("value");

        currentConfiguration.data.customOptions = currentConfiguration.data.customOptions.filter(e => e.id != option);
        if (value != "-" && value != "") {
            currentConfiguration.data.customOptions.push({ id: option, value: value });
        }

        updateSummaryMenuTotalPrice();
        window.dispatchEvent(new Event("saveconfigurations"));
    }, ".options-modal .options select");

    Y.one("body").delegate("change", function (e) {
        if (currentConfiguration.data.customOptions == undefined) {
            currentConfiguration.data.customOptions = [];
        }

        let input = e.currentTarget;

        let element = input.getData("element");
        let option = input.getData("option");
        let value = input.getData("value");
        let selected = input.get("checked");

        if(element){
            const entity = currentModule.entities.find(e => e.id == element);
            if (entity.customOptions == undefined) {
                entity.customOptions = [];
            }

            entity.customOptions = entity.customOptions.filter(e => e.id != option);
            if (selected) {
                entity.customOptions.push({ id: option, value: value });
            }
        }else{
            currentConfiguration.data.customOptions = currentConfiguration.data.customOptions.filter(e => e.id != option);
            if (selected) {
                currentConfiguration.data.customOptions.push({ id: option, value: value });
            }
        }
        updateSummaryMenuTotalPrice();
        window.dispatchEvent(new Event("saveconfigurations"));
    }, ".options-modal .options input[type=checkbox]");



    Y.one("body").delegate("change", function (e) {
        updateMaterialGroupModal();
    }, ".materialfilter");

    Y.one("body").delegate("keyup", debounce(function (e) {
        updateMaterialGroupModal();
    }, 250), "#materialsearchfilter");

    /* Y.one("body").delegate("change", function (e) {
 
         showMetrics = !showMetrics;
 
         if (showMetrics) {
             Metrics.CreateModuleRulers(currentModule, productLibrary, scene, rulerGUI);
         } else {
             Metrics.ClearMetrics(scene, rulerGUI);
         }
 
     }, ".config-menu__metrics");*/

    Y.one("body").delegate("click", function (e) {

        var username = Y.one("#email").get("value");
        var password = Y.one("#password").get("value");

        var cfg = {
            method: 'POST',
            data: JSON.stringify({ username: username, password: password }),
            headers: {
                'Content-Type': 'application/json',
            },
            on: {
                success: function (transactionid, response) {
                    var authJSON = JSON.parse(response.responseText);
                    window.localStorage.setItem("accessToken", authJSON.accessToken);
                    window.localStorage.setItem("refreshToken", authJSON.refreshToken);
                    handleLogin();
                },
                failure: function (transactionid, response) {
                    window.localStorage.removeItem("accessToken");
                    window.localStorage.removeItem("refreshToken");
                    handleLogin();
                }
            }

        };

        Y.io('api/auth/login', cfg);

    }, ".login-btn");

    Y.one(".modal").delegate("click", function (e) {

        var target = e.currentTarget;
        var parent = target.ancestor(".modal");
        parent.removeClass("is-active");

    }, ".modal-background, .modal-close");

    Y.one(".material-group-modal").delegate("click", function (e) {

        var target = e.currentTarget;
        var parent = target.ancestor(".modal");

        var groupId = target.getAttribute("data-group");

        // materialSelector.setConfiguration(currentConfiguration);
        materialSelector.setMaterialGroup(groupId);
        materialSelector.update();

        parent.removeClass("is-active");

    }, ".modal-card-body ul li");

    Y.one(".options-modal").delegate("click", function (e) {

        var renderButton = Y.one(e.target);
        renderButton.set("disabled", "disabled");

        renderConfigurationImages(currentConfiguration, () => {
            renderButton.set("disabled", null);
        });
    }, ".renderConfiguration");
});